function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["onChange"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { NetworkStatus, useMutation, useQuery } from "@apollo/client";
import { Field, FieldArray, Form as FormikForm, Formik, getIn } from "formik";
import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Table from "react-bootstrap/Table";
import * as Yup from "yup";
import { UserContext, FilterContext, SearchContext } from "../index";
import "./Employees.css";
import { DELETE_USER_MUTATION, EDIT_USER_MUTATION, ORGANISATION_USERS_QUERY, USER_ROLES_QUERY, ORGANISATION_TEAMS_QUERY, RESENT_INVITE_LINK_MUTATION, USER_WORK_DAY_SETTINGS_QUERY, ADD_USER_WORK_DAY_SETTINGS_MUTATION, GET_PAID_AND_UNUSED_USER_COUNT_QUERY, ADD_BILLABLE_RATE_MUTATION, ORGANISATION_USERS_COUNT_QUERY, ADD_LABOUR_COST_MUTATION, ORGANISATION_CURRENCY_SETTING_QUERY, LOGOUT_ALL_DEVICES_MUTATION, APP_VERSION_LIST_QUERY, UPDATE_ORGANISATION_SETTINGS_FOR_USER_MUTATION } from "./query";
import { USER_SIDE_MENU_QUERY, ORGANISATION_TEAMS_AND_ROLE_QUERY } from "../SideMenu/query";
import { TEAM_DETAILS_QUERY } from "../Teams/query";
import Loader from "./../Loader/Loader";
import { toast } from "react-toastify";
import { findDemoOrLiveSite } from "../SideMenu/Header";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { AddEmployees } from "./EmployeesModal";
import { HiQuestionMarkCircle, HiOutlineDotsVertical } from "react-icons/hi";
import Dropdown from "react-bootstrap/Dropdown";
import classNames from "classnames";
import DatePicker from "react-datepicker";
import Alert from "react-bootstrap/Alert";
import moment from "moment-timezone";
import Select from "react-select";
import { ScreenshotList, IdelTimeThresholdList } from "../TimesheetSettings/data";
import { WEB_ORGANISATION_SETTINGS_QUERY } from "../TimesheetSettings/query";
import { findIsWorkfolioSite, isRateLimited } from "../utils";
import { MdDeleteForever, MdModeEdit } from "react-icons/md";
import subDays from "date-fns/subDays";
import TimePicker from "rc-time-picker";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Password from "./PassWordEdit";
import { timezoneList, expectedWorkingHourData, WorkingDaysList } from "./../TimesheetSettings/data";
var LIMIT = 20;
var offsets = 0;
var UserSchema = Yup.object().shape({
  email: Yup.string().trim().email("Enter a valid email").required("Required").matches(/^[^\s@+]+@[^\s@]+\.[^\s@]+$/, "The '+' symbol is not allowed."),
  displayName: Yup.string().trim().required("Required").matches(/^[\u4E00-\u9FFF A-Za-z0-9'.-]+$/, "Invalid characters"),
  employeeId: Yup.string().max(15, "Employee ID cannot exceed 15 characters."),
  designation: Yup.string().max(100, "Designation cannot exceed 100 characters."),
  teams: Yup.array().of(Yup.object().shape({
    teamId: Yup.string().required("Required"),
    roleId: Yup.string().required("Required")
  })).required("Please add teams").min(1, "Add atleast 1 team")
  // 🔥 ADD THIS BLOCK
  .test("unique-team", "A person cannot be assigned to the same team more than once.", function (teams) {
    if (!teams) return true;
    var filtered = teams.map(function (t) {
      return t.teamId;
    }).filter(function (id) {
      return id && id !== "allTeam";
    });
    return new Set(filtered).size === filtered.length;
  })
});
var AddUsersSchema = Yup.object().shape({
  users: Yup.array().of(UserSchema).required("Please add users").min(1, "Add atleast 1 user")
});
var errorMessage = function errorMessage(errors, touched, name) {
  var error = getIn(errors, name);
  var touch = getIn(touched, name);
  if (touch && error) {
    return /*#__PURE__*/React.createElement(Form.Label, {
      className: "error"
    }, error);
  }
  return null;
};
var BillableSchema = Yup.object().shape({
  amount: Yup.number().positive().min(0, "only positive value")
});
var LabourSchema = Yup.object().shape({
  amount: Yup.number().positive().min(0, "only positive value")
});
var ColumnNameList = ["Account Details", "App Version", "Team"];
var MobileViewColumnNameList = ["Account Details"];
var Employees = function Employees(props) {
  var _data$organisationUse, _data$organisationUse2, _userCount$organisati, _data$organisationUse3, _currenciesData$getOr, _data$organisationUse4, _currenciesData$getOr2, _currenciesData$getOr3;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    employeeDetails = _useState2[0],
    setEmployeeDetails = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    employeeUserId = _useState4[0],
    setEmployeeUserId = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    employeeUserRole = _useState6[0],
    setEmployeeUserRole = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    employeeBillableModal = _useState8[0],
    setEmployeeBillableModal = _useState8[1];
  var _React$useContext = React.useContext(UserContext),
    user = _React$useContext.user,
    setUser = _React$useContext.setUser;
  var _React$useContext2 = React.useContext(FilterContext),
    organisationId = _React$useContext2.organisationId,
    teamId = _React$useContext2.teamId,
    teamName = _React$useContext2.teamName,
    role = _React$useContext2.role,
    organisationBilling = _React$useContext2.organisationBilling,
    from = _React$useContext2.from,
    organisationSettings = _React$useContext2.organisationSettings;
  var _React$useContext3 = React.useContext(SearchContext),
    search = _React$useContext3.search;
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    inviteType = _useState10[0],
    setInviteType = _useState10[1];
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isAllLoaded = _React$useState2[0],
    setIsAllLoaded = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isLoadingMore = _React$useState4[0],
    setIsLoadingMore = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isLoadMoreButton = _React$useState6[0],
    setIsLoadMoreButton = _React$useState6[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    employeeLabourCostModal = _useState12[0],
    setEmployeeLabourCostModal = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    editUserData = _useState14[0],
    setEditUserData = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    deleteUserData = _useState16[0],
    setDeleteUserData = _useState16[1];
  var _React$useState7 = React.useState("edit"),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    tabData = _React$useState8[0],
    setTabData = _React$useState8[1];
  var _React$useState9 = React.useState({
      label: "All Roles",
      value: "all"
    }),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    roleParameterCheck = _React$useState10[0],
    setRoleParameterCheck = _React$useState10[1];
  var _React$useState11 = React.useState({
      label: "All Teams",
      value: "all"
    }),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    teamParameterCheck = _React$useState12[0],
    setTeamParameterCheck = _React$useState12[1];
  var _React$useState13 = React.useState({
      label: "All OS",
      value: "all"
    }),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    osParameterCheck = _React$useState14[0],
    setOsParameterCheck = _React$useState14[1];
  var _React$useState15 = React.useState({
      label: "All Appversion",
      value: "all"
    }),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    appVersionParameterCheck = _React$useState16[0],
    setAppVersionParameterCheck = _React$useState16[1];

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);
  React.useEffect(function () {
    if (from == "web" && role == "Member") {
      props === null || props === void 0 ? void 0 : props.history.push("/my-work");
    }
  }, [role]);
  React.useEffect(function () {
    if ((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null && (role == "Admin" || role == "Head")) {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  React.useEffect(function () {
    setIsAllLoaded(false);
    setIsLoadingMore(false);
    offsets = 0;
  }, [roleParameterCheck, teamParameterCheck, osParameterCheck, appVersionParameterCheck]);
  var loadPage = role === "Admin" || role === "Head" || role === null;
  var Redirect = props.redirect,
    match = props.match,
    Link = props.linkComponent,
    linkProps = props.linkProps;
  var userId = user === null || user === void 0 ? void 0 : user.userId;
  var handleClose = function handleClose() {
    setEmployeeDetails(null);
    setInviteType(null);
    setEmployeeUserId(null);
    setEmployeeUserRole(null);
    setEmployeeBillableModal(null);
    setEmployeeLabourCostModal(null);
    setTabData("edit");
  };
  var handleShow = function handleShow(employee) {
    setEmployeeDetails(employee);
  };
  var handleShowForSettings = function handleShowForSettings(_ref) {
    var userId = _ref.userId,
      userRole = _ref.userRole;
    setEmployeeUserId(userId);
    setEmployeeUserRole(userRole);
  };
  var handleShowForbillableSettings = function handleShowForbillableSettings(userId, billableRate, displayName, billableRateType) {
    var t = {
      userId: userId,
      billableRate: billableRate,
      displayName: displayName,
      billableRateType: billableRateType
    };
    setEmployeeBillableModal(t);
  };
  var handleShowForLabourCostSettings = function handleShowForLabourCostSettings(userId, labourCost, displayName, labourCostType) {
    var t = {
      userId: userId,
      labourCost: labourCost,
      displayName: displayName,
      labourCostType: labourCostType
    };
    setEmployeeLabourCostModal(t);
  };
  var _useQuery = useQuery(ORGANISATION_USERS_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamParameterCheck ? teamParameterCheck.value : null,
        userRole: role,
        limit: LIMIT,
        offset: 0,
        searchText: search,
        os: osParameterCheck ? osParameterCheck === null || osParameterCheck === void 0 ? void 0 : osParameterCheck.value : null,
        appVersion: appVersionParameterCheck ? appVersionParameterCheck === null || appVersionParameterCheck === void 0 ? void 0 : appVersionParameterCheck.value : null,
        roleFilter: roleParameterCheck ? roleParameterCheck.value : null
      },
      skip: !loadPage
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading,
    fetchMore = _useQuery.fetchMore,
    userRefetch = _useQuery.refetch;
  var _useQuery2 = useQuery(ORGANISATION_USERS_COUNT_QUERY, {
      variables: _defineProperty(_defineProperty(_defineProperty(_defineProperty({
        organisationId: organisationId,
        teamId: teamId,
        userRole: role
      }, "teamId", teamParameterCheck ? teamParameterCheck.value : null), "os", osParameterCheck ? osParameterCheck === null || osParameterCheck === void 0 ? void 0 : osParameterCheck.value : null), "appVersion", appVersionParameterCheck ? appVersionParameterCheck === null || appVersionParameterCheck === void 0 ? void 0 : appVersionParameterCheck.value : null), "roleFilter", roleParameterCheck ? roleParameterCheck.value : null),
      skip: !loadPage
    }),
    userCount = _useQuery2.data,
    userError = _useQuery2.error,
    userLoading = _useQuery2.loading,
    userCountRefetch = _useQuery2.refetch;
  var _useQuery3 = useQuery(USER_ROLES_QUERY, {
      variables: {
        organisationId: organisationId
      }
    }),
    rolesData = _useQuery3.data,
    rolesError = _useQuery3.error,
    rolesLoading = _useQuery3.loading;
  var _useQuery4 = useQuery(ORGANISATION_TEAMS_QUERY, {
      variables: {
        organisationId: organisationId
      }
    }),
    teamsData = _useQuery4.data,
    teamsError = _useQuery4.error,
    teamsLoading = _useQuery4.loading;

  // const { data: appVersionData, error: appVersionError, loading: appVersionLoading } = useQuery(APP_VERSION_LIST_QUERY);

  var _useQuery5 = useQuery(ORGANISATION_CURRENCY_SETTING_QUERY, {
      variables: {
        organisationId: organisationId
      },
      skip: !loadPage
    }),
    currenciesData = _useQuery5.data,
    currenciesError = _useQuery5.error,
    currenciesLoading = _useQuery5.loading,
    currenciesRefetch = _useQuery5.refetch;
  React.useEffect(function () {
    userRefetch === null || userRefetch === void 0 ? void 0 : userRefetch();
    setIsAllLoaded(false);
    userCountRefetch === null || userCountRefetch === void 0 ? void 0 : userCountRefetch();
    setEditUserData([]);
    setDeleteUserData([]);
    offsets = 0;
    currenciesRefetch === null || currenciesRefetch === void 0 ? void 0 : currenciesRefetch();
  }, [props.location.key, teamId]);
  React.useEffect(function () {
    userRefetch === null || userRefetch === void 0 ? void 0 : userRefetch();
    setIsAllLoaded(false);
    userCountRefetch === null || userCountRefetch === void 0 ? void 0 : userCountRefetch();
    setEditUserData([]);
    setDeleteUserData([]);
    offsets = 0;
  }, [search]);
  var _useMutation = useMutation(DELETE_USER_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    deleteUser = _useMutation2[0],
    deleting = _useMutation2[1].loading;
  var onDelete = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(userId) {
      var response, _deleteUser;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!deleting) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            _context.prev = 2;
            _context.next = 5;
            return deleteUser({
              variables: {
                organisationId: organisationId,
                userId: userId
              },
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: USER_SIDE_MENU_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  limit: 20,
                  offset: 0,
                  search: null,
                  userRole: role
                }
              }, {
                query: GET_PAID_AND_UNUSED_USER_COUNT_QUERY,
                variables: {
                  organisationId: organisationId
                }
              }, {
                query: ORGANISATION_USERS_COUNT_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userRole: role
                }
              }, {
                query: TEAM_DETAILS_QUERY,
                variables: {
                  organisationId: organisationId
                }
              }]
              //update: handleDeleteUser(organisationId, userId, teamId, role, search),
            });
          case 5:
            response = _context.sent;
            if (response && response.data && response.data.deleteUser !== "") {
              _deleteUser = _toConsumableArray(deleteUserData);
              _deleteUser.push(response.data.deleteUser);
              setDeleteUserData(_toConsumableArray(_deleteUser));
              toast.success("User deleted successfully!");
            }
            _context.next = 12;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](2);
            // deleteUser shares the one-hour bulk-write bucket with addUsers and
            // editUser. Other failures stay silent here, as before.
            if (isRateLimited(_context.t0)) {
              toast.error("Too many user changes in a short time. Please try again in an hour.");
            }
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 9]]);
    }));
    return function onDelete(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var _useMutation3 = useMutation(RESENT_INVITE_LINK_MUTATION),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    resentInviteLink = _useMutation4[0],
    updating = _useMutation4[1].loading;
  var resentLink = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(userId) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!updating) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            _context2.prev = 2;
            _context2.next = 5;
            return resentInviteLink({
              variables: {
                organisationId: organisationId,
                userId: userId
              }
            });
          case 5:
            toast.success("Invite link sent successfully");
            _context2.next = 10;
            break;
          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](2);
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 8]]);
    }));
    return function resentLink(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var roles = !rolesLoading && !rolesError ? rolesData === null || rolesData === void 0 ? void 0 : rolesData.userRoles : null;
  var teams = !teamsLoading && !teamsError ? teamsData === null || teamsData === void 0 ? void 0 : teamsData.organisationTeams : null;

  // filter based text display
  var teamNameNew = [];
  if (teams !== null) {
    teamNameNew = teams.reduce(function (acc, curr, index) {
      if (curr.teamId === teamId) {
        acc.push({
          teamName: curr.teamName
        });
      }
      return acc;
    }, []);
  }
  var teamNames = "All Team";
  if (teamNameNew.length) {
    teamNames = teamNameNew[0].teamName;
  }
  if (!loadPage) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/"
    });
  }
  var isDemoOrLiveSite = findDemoOrLiveSite();
  var siteName = findIsWorkfolioSite();
  var handleLoadMore = function handleLoadMore() {
    if (loading) return;
    setIsLoadingMore(true);
    offsets = offsets + 1;
    fetchMore({
      variables: {
        offset: offsets * LIMIT
      },
      updateQuery: function updateQuery(prev, _ref4) {
        var _fetchMoreResult$orga, _fetchMoreResult$orga2, _fetchMoreResult$orga3;
        var fetchMoreResult = _ref4.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$orga = fetchMoreResult.organisationUsers) === null || _fetchMoreResult$orga === void 0 ? void 0 : _fetchMoreResult$orga.length) === 0 && ((_fetchMoreResult$orga2 = fetchMoreResult.organisationUsers) === null || _fetchMoreResult$orga2 === void 0 ? void 0 : _fetchMoreResult$orga2.length) < LIMIT && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        setIsLoadingMore(false);
        var NewFilterData = [];
        (_fetchMoreResult$orga3 = fetchMoreResult.organisationUsers) === null || _fetchMoreResult$orga3 === void 0 ? void 0 : _fetchMoreResult$orga3.forEach(function (newTask) {
          var found = prev.organisationUsers.find(function (item) {
            return item.userId === newTask.userId;
          });
          if (!found) {
            // If not found, add validation.
            NewFilterData.push(newTask);
          }
        });
        return _objectSpread(_objectSpread({}, prev), {}, {
          organisationUsers: [].concat(_toConsumableArray(prev.organisationUsers), NewFilterData)
        });
      }
    });
  };
  if ((data === null || data === void 0 ? void 0 : (_data$organisationUse = data.organisationUsers) === null || _data$organisationUse === void 0 ? void 0 : _data$organisationUse.length) !== 0 && (data === null || data === void 0 ? void 0 : (_data$organisationUse2 = data.organisationUsers) === null || _data$organisationUse2 === void 0 ? void 0 : _data$organisationUse2.length) < LIMIT && !isAllLoaded) {
    setIsAllLoaded(true);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "manage-employee-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "Employees-root-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "Employees-root-header-left-side"
  }, /*#__PURE__*/React.createElement("div", {
    className: "Employees-root-header-filter-name"
  }, "Showing ", teamNames == "All Team" ? "All Members" : teamNames, " (", userCount === null || userCount === void 0 ? void 0 : (_userCount$organisati = userCount.organisationUsersCount) === null || _userCount$organisati === void 0 ? void 0 : _userCount$organisati.userCount, ")"), isDemoOrLiveSite === "demo" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-demo-site"
    }, "You can't add employee in demo site.")
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "Employees-root-header-left-side-button disable-button"
  }, "Add New Employee")) : siteName === "workfolio" ? organisationBilling.userCount === 0 || (data === null || data === void 0 ? void 0 : (_data$organisationUse3 = data.organisationUsers) === null || _data$organisationUse3 === void 0 ? void 0 : _data$organisationUse3.length) < organisationBilling.userCount ? /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "Employees-root-header-left-side-button",
    "data-tut": "reactour__iso",
    onClick: function onClick() {
      return handleShow({});
    }
  }, "Add New Employee") : /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to add a new employee")
  }, /*#__PURE__*/React.createElement("div", {
    className: "Employees-root-header-left-side-button upgrade-plan-button-color-employee"
  }, "Add New Employee")) : null)), /*#__PURE__*/React.createElement("div", {
    className: "Employees-root-content",
    "data-tut": "reactour__logo"
  }, /*#__PURE__*/React.createElement(EmployeeFilter, {
    teamsData: teamsData,
    teamsLoading: teamsLoading,
    roleParameterCheck: roleParameterCheck,
    setRoleParameterCheck: setRoleParameterCheck,
    teamParameterCheck: teamParameterCheck,
    setTeamParameterCheck: setTeamParameterCheck,
    osParameterCheck: osParameterCheck,
    setOsParameterCheck: setOsParameterCheck,
    appVersionParameterCheck: appVersionParameterCheck,
    setAppVersionParameterCheck: setAppVersionParameterCheck
    // appVersionList={appVersionData?.appVersionList}
  }), /*#__PURE__*/React.createElement(EmployeeList, {
    onDelete: onDelete,
    resentLink: resentLink,
    handleShow: handleShow,
    handleShowForSettings: handleShowForSettings,
    employees: data === null || data === void 0 ? void 0 : data.organisationUsers,
    search: search,
    isDemoOrLiveSite: isDemoOrLiveSite,
    type: "active",
    teamId: teamId,
    user: user,
    planId: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId,
    Link: Link,
    linkProps: linkProps,
    organisationSettings: organisationSettings,
    handleShowForbillableSettings: handleShowForbillableSettings,
    isAllLoaded: isAllLoaded,
    isLoadingMore: isLoadingMore,
    isLoadMoreButton: isLoadMoreButton,
    handleLoadMore: handleLoadMore,
    handleShowForLabourCostSettings: handleShowForLabourCostSettings,
    editUserData: editUserData,
    setEditUserData: setEditUserData,
    deleteUserData: deleteUserData,
    setDeleteUserData: setDeleteUserData,
    role: role,
    currenciesData: currenciesData === null || currenciesData === void 0 ? void 0 : (_currenciesData$getOr = currenciesData.getOrganisationCurrencies) === null || _currenciesData$getOr === void 0 ? void 0 : _currenciesData$getOr.currencies,
    planStatus: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus,
    loading: loading,
    error: error
  }), /*#__PURE__*/React.createElement(AddEmployees, {
    roles: roles,
    teams: teams,
    show: employeeDetails && Object.keys(employeeDetails) < 1,
    handleClose: handleClose,
    teamId: teamId,
    inviteType: inviteType,
    setInviteType: setInviteType,
    organisationId: organisationId,
    userId: userId,
    teamsData: teamsData,
    urlPath: match.path,
    organisationBilling: organisationBilling,
    employeeCount: data === null || data === void 0 ? void 0 : (_data$organisationUse4 = data.organisationUsers) === null || _data$organisationUse4 === void 0 ? void 0 : _data$organisationUse4.length,
    role: role
  }), /*#__PURE__*/React.createElement(EditEmployee, {
    roles: roles,
    teams: teams,
    employeeDetails: employeeDetails && Object.keys(employeeDetails).length > 0 ? employeeDetails : null,
    handleClose: handleClose,
    teamId: teamId,
    role: role,
    editUserData: editUserData,
    setEditUserData: setEditUserData,
    user: user,
    setUser: setUser,
    tabData: tabData,
    setTabData: setTabData
  }), /*#__PURE__*/React.createElement(EmployeeSetting, {
    employeeUserId: employeeUserId,
    handleClose: handleClose,
    organisationId: organisationId,
    organisationSettings: organisationSettings,
    employeeUserRole: employeeUserRole,
    organisationBilling: organisationBilling
  }), /*#__PURE__*/React.createElement(EmployeeBillable, {
    employeeBillableModal: employeeBillableModal,
    handleClose: handleClose,
    organisationId: organisationId,
    teamId: teamId,
    role: role,
    organisationBilling: organisationBilling,
    organisationSettings: organisationSettings,
    editUserData: editUserData,
    setEditUserData: setEditUserData,
    setIsAllLoaded: setIsAllLoaded,
    currenciesData: currenciesData === null || currenciesData === void 0 ? void 0 : (_currenciesData$getOr2 = currenciesData.getOrganisationCurrencies) === null || _currenciesData$getOr2 === void 0 ? void 0 : _currenciesData$getOr2.currencies
  }), /*#__PURE__*/React.createElement(EmployeeLabourCost, {
    employeeLabourCostModal: employeeLabourCostModal,
    handleClose: handleClose,
    organisationId: organisationId,
    teamId: teamId,
    role: role,
    organisationBilling: organisationBilling,
    organisationSettings: organisationSettings,
    editUserData: editUserData,
    setEditUserData: setEditUserData,
    setIsAllLoaded: setIsAllLoaded,
    currenciesData: currenciesData === null || currenciesData === void 0 ? void 0 : (_currenciesData$getOr3 = currenciesData.getOrganisationCurrencies) === null || _currenciesData$getOr3 === void 0 ? void 0 : _currenciesData$getOr3.currencies
  })));
};
var EmployeeList = /*#__PURE__*/React.memo(function EmployeeList(props) {
  var _employeeWithSearch;
  var employees = props.employees,
    _onDelete = props.onDelete,
    _resentLink = props.resentLink,
    type = props.type,
    search = props.search,
    handleShow = props.handleShow,
    isDemoOrLiveSite = props.isDemoOrLiveSite,
    teamId = props.teamId,
    user = props.user,
    handleShowForSettings = props.handleShowForSettings,
    planId = props.planId,
    Link = props.Link,
    linkProps = props.linkProps,
    organisationSettings = props.organisationSettings,
    handleShowForbillableSettings = props.handleShowForbillableSettings,
    isAllLoaded = props.isAllLoaded,
    isLoadingMore = props.isLoadingMore,
    isLoadMoreButton = props.isLoadMoreButton,
    handleLoadMore = props.handleLoadMore,
    handleShowForLabourCostSettings = props.handleShowForLabourCostSettings,
    editUserData = props.editUserData,
    setEditUserData = props.setEditUserData,
    deleteUserData = props.deleteUserData,
    setDeleteUserData = props.setDeleteUserData,
    role = props.role,
    currenciesData = props.currenciesData,
    planStatus = props.planStatus,
    loading = props.loading,
    error = props.error;
  var _React$useState17 = React.useState(null),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    keyData = _React$useState18[0],
    setKeyData = _React$useState18[1];
  var _React$useState19 = React.useState(false),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    isCheck = _React$useState20[0],
    setIsCheck = _React$useState20[1];
  var _React$useState21 = React.useState(false),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    isNavClick = _React$useState22[0],
    setNavClick = _React$useState22[1];
  var employeeWithSearch = function employeeWithSearch(employees) {
    if (!search) {
      return employees;
    }
    return employees.filter(function (employee) {
      var _employee$displayName, _employee$displayName2, _employee$email$toLow, _employee$email$toLow2;
      return ((_employee$displayName = employee.displayName.toLowerCase()) === null || _employee$displayName === void 0 ? void 0 : (_employee$displayName2 = _employee$displayName.includes) === null || _employee$displayName2 === void 0 ? void 0 : _employee$displayName2.call(_employee$displayName, search.toLowerCase())) || ((_employee$email$toLow = employee.email.toLowerCase()) === null || _employee$email$toLow === void 0 ? void 0 : (_employee$email$toLow2 = _employee$email$toLow.includes) === null || _employee$email$toLow2 === void 0 ? void 0 : _employee$email$toLow2.call(_employee$email$toLow, search.toLowerCase()));
    });
  };
  var isMobileView = window.innerWidth < 768;
  var _useMutation5 = useMutation(LOGOUT_ALL_DEVICES_MUTATION),
    _useMutation6 = _slicedToArray(_useMutation5, 2),
    logoutAllDevices = _useMutation6[0],
    updating = _useMutation6[1].loading;
  var handleLogoutAllDevices = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(userId, displayName, loginUserId) {
      var response;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!updating) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return");
          case 2:
            _context3.prev = 2;
            _context3.next = 5;
            return logoutAllDevices({
              variables: {
                userId: userId
              }
            });
          case 5:
            response = _context3.sent;
            if (response && response.data && response.data.logoutAllDevices) {
              toast.success("Logged out ".concat(displayName, "'s devices \u2705"));
              if (loginUserId == userId) {
                localStorage.removeItem("token");
                window.location.href = "/login"; // or use your router's navigation
              }
            }
            _context3.next = 12;
            break;
          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](2);
            toast.error("Failed to logout ".concat(displayName, "'s devices \u274C"));
          case 12:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[2, 9]]);
    }));
    return function handleLogoutAllDevices(_x3, _x4, _x5) {
      return _ref5.apply(this, arguments);
    };
  }();

  //console.log({currenciesData})

  if (loading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (error) {
    return /*#__PURE__*/React.createElement("div", {
      className: "common-err-refresh-text"
    }, "Something went wrong, please refresh the page.");
  }
  if (!employees) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, employees.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, isMobileView ? /*#__PURE__*/React.createElement(MobileViewTable, {
    type: type,
    employeeWithSearch: employeeWithSearch,
    isDemoOrLiveSite: isDemoOrLiveSite,
    resentLink: _resentLink,
    onDelete: _onDelete,
    handleShow: handleShow,
    employees: employees,
    handleShowForSettings: handleShowForSettings,
    planId: planId,
    organisationSettings: organisationSettings,
    handleShowForbillableSettings: handleShowForbillableSettings,
    user: user,
    editUserData: editUserData,
    deleteUserData: deleteUserData,
    role: role
  }) : /*#__PURE__*/React.createElement(Table, {
    borderless: true,
    className: "Employees-root-content-table"
  }, /*#__PURE__*/React.createElement("thead", {
    className: "Employees-root-content-data-header"
  }, /*#__PURE__*/React.createElement("tr", null, ColumnNameList.map(function (columnName) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, columnName == "App Version" && organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.projectManagementFeature ? null : /*#__PURE__*/React.createElement("th", {
      key: columnName
    }, columnName));
  }), organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.projectManagementFeature ? /*#__PURE__*/React.createElement("th", null, "Billable Rate") : null, organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.projectManagementFeature ? /*#__PURE__*/React.createElement("th", null, "Labour Cost") : null, type === "active" ? /*#__PURE__*/React.createElement("th", null) : null)), /*#__PURE__*/React.createElement("tbody", null, employees.map(function (employee, key) {
    var _teams, _teams2, _teams3;
    var profileUrl = employee.profileUrl,
      displayName = employee.displayName,
      passwordStatus = employee.passwordStatus,
      uniqueUrl = employee.uniqueUrl,
      appVersion = employee.appVersion,
      appIcon = employee.appIcon,
      email = employee.email,
      userId = employee.userId,
      teams = employee.teams,
      billableRate = employee.billableRate,
      labourCost = employee.labourCost,
      organisationCreatedBy = employee.organisationCreatedBy,
      status = employee.status,
      billableRateType = employee.billableRateType,
      labourCostType = employee.labourCostType,
      employeeId = employee.employeeId,
      userRole = employee.userRole,
      dateOfBirth = employee.dateOfBirth,
      dateOfJoining = employee.dateOfJoining,
      designation = employee.designation;
    if (deleteUserData.length > 0 && deleteUserData.includes(userId)) {
      return;
    }
    var findEditUserId = editUserData.find(function (user) {
      return user.userId === userId;
    }) || {};
    if (editUserData.length !== 0 && Object.keys(findEditUserId).length > 0) {
      displayName = findEditUserId.displayName;
      email = findEditUserId.email;
      profileUrl = findEditUserId.profileUrl;
      teams = (findEditUserId === null || findEditUserId === void 0 ? void 0 : findEditUserId.teams) || teams;
      uniqueUrl = findEditUserId.uniqueUrl;
      userId = findEditUserId.userId;
      billableRate = (findEditUserId === null || findEditUserId === void 0 ? void 0 : findEditUserId.billableRate) || billableRate;
      labourCost = (findEditUserId === null || findEditUserId === void 0 ? void 0 : findEditUserId.labourCost) || labourCost;
      billableRateType = (findEditUserId === null || findEditUserId === void 0 ? void 0 : findEditUserId.billableRateType) || billableRateType;
      labourCostType = (findEditUserId === null || findEditUserId === void 0 ? void 0 : findEditUserId.labourCostType) || labourCostType;
      employeeId = (findEditUserId === null || findEditUserId === void 0 ? void 0 : findEditUserId.employeeId) || employeeId;
      dateOfBirth = (findEditUserId === null || findEditUserId === void 0 ? void 0 : findEditUserId.dateOfBirth) || dateOfBirth;
      dateOfJoining = (findEditUserId === null || findEditUserId === void 0 ? void 0 : findEditUserId.dateOfJoining) || dateOfJoining;
      designation = (findEditUserId === null || findEditUserId === void 0 ? void 0 : findEditUserId.designation) || designation;
      userRole = (findEditUserId === null || findEditUserId === void 0 ? void 0 : findEditUserId.userRole) || userRole;
    }
    {
      var _displayName;
      profileUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "employee-card-avatar-profile"
      }, /*#__PURE__*/React.createElement("img", {
        alt: "Workfolio",
        src: profileUrl,
        className: "team-card-avatar-profile-img"
      }))) : /*#__PURE__*/React.createElement("div", {
        className: "team-card-avatar"
      }, (_displayName = displayName) === null || _displayName === void 0 ? void 0 : _displayName.charAt(0));
    }
    return /*#__PURE__*/React.createElement("tr", {
      key: userId,
      className: classNames("Employees-root-content-data-details", {
        "Employees-root-content-data-details-passwors-status": passwordStatus === false
      })
    }, /*#__PURE__*/React.createElement("td", {
      className: "Employees-root-content-data-details-td-name"
    }, /*#__PURE__*/React.createElement("div", {
      className: "Employees-root-content-data-details-avatar"
    }, profileUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "employee-card-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Workfolio",
      src: profileUrl,
      className: "team-card-avatar-profile-img"
    }))) : /*#__PURE__*/React.createElement("div", {
      className: "Employees-root-content-data-details-avatar-circle text-white"
    }, displayName.charAt(0)), /*#__PURE__*/React.createElement("div", {
      className: "Employees-root-content-data-details-name-data"
    }, /*#__PURE__*/React.createElement("div", {
      className: "Employees-root-content-data-details-name-data-team-name-whole"
    }, /*#__PURE__*/React.createElement(Link, _extends({}, _defineProperty({}, linkProps, "/personal-statistics/".concat(uniqueUrl)), {
      key: "employee-".concat(uniqueUrl)
    }), /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, displayName, appIcon ? /*#__PURE__*/React.createElement("div", null, "OS:", " ", appIcon == "Windows" ? /*#__PURE__*/React.createElement("span", null, appIcon, " ", /*#__PURE__*/React.createElement("img", {
        src: "https://workfolio-public.s3.ap-south-1.amazonaws.com/icons8-windows-10-50.webp",
        alt: "windows",
        className: "employee-page-app-version-icon employee-page-app-version-icon-hover"
      })) : appIcon == "Mac" ? /*#__PURE__*/React.createElement("span", null, appIcon, " ", /*#__PURE__*/React.createElement("img", {
        src: "https://workfolio-public.s3.ap-south-1.amazonaws.com/icons8-mac-client-90.webp",
        alt: "mac",
        className: "employee-page-app-version-icon employee-page-app-version-icon-hover"
      })) : appIcon == "Linux" ? /*#__PURE__*/React.createElement("span", null, appIcon, " ", /*#__PURE__*/React.createElement("img", {
        src: "https://workfolio-public.s3.ap-south-1.amazonaws.com/icons8-ubuntu-96.webp",
        alt: "linux",
        className: "employee-page-app-version-icon employee-page-app-version-icon-hover"
      })) : null) : null, appVersion ? /*#__PURE__*/React.createElement("div", null, "App version: ", appVersion) : null)
    }, /*#__PURE__*/React.createElement("span", {
      //className="Employees-root-content-data-details-name-data-team-name"
      className: classNames("Employees-root-content-data-details-name-data-team-name", {
        "employee-page-name-password-status": passwordStatus === false
      })
    }, displayName, organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.projectManagementFeature && appVersion != null ? /*#__PURE__*/React.createElement("span", {
      className: "employee-page-app-version"
    }, appIcon == "Windows" ? /*#__PURE__*/React.createElement("img", {
      src: "https://workfolio-public.s3.ap-south-1.amazonaws.com/icons8-windows-10-50.webp",
      alt: "windows",
      className: "employee-page-app-version-icon employee-page-app-version-icon-windows"
    }) : appIcon == "Mac" ? /*#__PURE__*/React.createElement("img", {
      src: "https://workfolio-public.s3.ap-south-1.amazonaws.com/icons8-mac-client-90.webp",
      alt: "mac",
      className: "employee-page-app-version-icon employee-page-app-version-icon-mac"
    }) : appIcon == "Linux" ? /*#__PURE__*/React.createElement("img", {
      src: "https://workfolio-public.s3.ap-south-1.amazonaws.com/icons8-ubuntu-96.webp",
      alt: "linux",
      className: "employee-page-app-version-icon employee-page-app-version-icon-linux"
    }) : null, " ", appVersion) : null)))), /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, email)
    }, /*#__PURE__*/React.createElement("div", {
      className: "Employees-root-table-email-name"
    }, email)), employeeId ? /*#__PURE__*/React.createElement("div", {
      className: "Employees-root-content-data-details-td-employee-id-data"
    }, "Emp ID: ", employeeId) : null, organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.projectManagementFeature ? passwordStatus === true ? null : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "employee-page-password-status"
    }, "Yet to accept the invite")) : null, organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.hideEditTrackSettingsFromTeamHeads && role == "Head" || role == "Head" && userRole == "Admin" ? null : passwordStatus === true ? planId === "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" || planStatus == "stopped" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "Please upgrade your plan to edit track settings")
    }, /*#__PURE__*/React.createElement("div", {
      className: "employee-page-track-set"
    }, "Edit Track Settings"))) : role == "Admin" || role == "Head" && (user === null || user === void 0 ? void 0 : user.userId) != userId ? /*#__PURE__*/React.createElement("div", {
      className: "employee-page-track-set",
      onClick: function onClick() {
        return handleShowForSettings({
          userId: userId,
          userRole: userRole
        });
      }
    }, "Edit Track Settings") : null : /*#__PURE__*/React.createElement(React.Fragment, null, passwordStatus === false ? /*#__PURE__*/React.createElement("div", {
      className: "employee-page-password-status-resend-link",
      onClick: function onClick() {
        return _resentLink(userId);
      }
    }, "Resend Invite Link") : null)))), !(organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.projectManagementFeature) ? /*#__PURE__*/React.createElement("td", {
      className: "Employees-root-content-data-details-td-email"
    }, passwordStatus === true ? /*#__PURE__*/React.createElement(React.Fragment, null, appVersion != null ? /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, "OS:", " ", appIcon == "Windows" ? /*#__PURE__*/React.createElement("span", null, appIcon, " ", /*#__PURE__*/React.createElement("img", {
        src: "https://workfolio-public.s3.ap-south-1.amazonaws.com/icons8-windows-10-50.webp",
        alt: "windows",
        className: "employee-page-app-version-icon"
      })) : appIcon == "Mac" ? /*#__PURE__*/React.createElement("span", null, appIcon, " ", /*#__PURE__*/React.createElement("img", {
        src: "https://workfolio-public.s3.ap-south-1.amazonaws.com/icons8-mac-client-90.webp",
        alt: "mac",
        className: "employee-page-app-version-icon"
      })) : appIcon == "Linux" ? /*#__PURE__*/React.createElement("span", null, appIcon, " ", /*#__PURE__*/React.createElement("img", {
        src: "https://workfolio-public.s3.ap-south-1.amazonaws.com/icons8-ubuntu-96.webp",
        alt: "linux",
        className: "employee-page-app-version-icon"
      })) : null), /*#__PURE__*/React.createElement("div", null, "App version: ", appVersion)))
    }, /*#__PURE__*/React.createElement("span", {
      className: "employee-page-app-version"
    }, appIcon == "Windows" ? /*#__PURE__*/React.createElement("img", {
      src: "https://workfolio-public.s3.ap-south-1.amazonaws.com/icons8-windows-10-50.webp",
      alt: "windows",
      className: "employee-page-app-version-icon employee-page-app-version-icon-hover"
    }) : appIcon == "Mac" ? /*#__PURE__*/React.createElement("img", {
      src: "https://workfolio-public.s3.ap-south-1.amazonaws.com/icons8-mac-client-90.webp",
      alt: "mac",
      className: "employee-page-app-version-icon employee-page-app-version-icon-hover"
    }) : appIcon == "Linux" ? /*#__PURE__*/React.createElement("img", {
      src: "https://workfolio-public.s3.ap-south-1.amazonaws.com/icons8-ubuntu-96.webp",
      alt: "linux",
      className: "employee-page-app-version-icon employee-page-app-version-icon-hover"
    }) : null, " ", appVersion)) : /*#__PURE__*/React.createElement("span", {
      className: "employee-page-app-version"
    }, "NA")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "employee-page-password-status"
    }, "Yet to accept the invite"))) : null, !(organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.projectManagementFeature) ? /*#__PURE__*/React.createElement("td", {
      className: "Employees-root-content-data-name-div-width-no-project-team"
    }, /*#__PURE__*/React.createElement(Dropdown, {
      open: isNavClick,
      className: classNames("employee-team-list-button-no-project .btn-primary")
    }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
      id: "dropdown-basics"
    }, ((_teams = teams) === null || _teams === void 0 ? void 0 : _teams.length) == 1 ? /*#__PURE__*/React.createElement("div", {
      className: "employee-span-no-project-team"
    }, teams[0].team.teamName, " (", teams[0].role.roleName === "Head" ? "Team Head" : teams[0].role.roleName === "Member" ? "Team Member" : teams[0].role.roleName, ")") : /*#__PURE__*/React.createElement("div", {
      className: "employee-span-no-project-team-add-more-div"
    }, /*#__PURE__*/React.createElement("div", {
      className: "employee-span-no-project-team-add-more"
    }, teams[0].team.teamName, " (", teams[0].role.roleName === "Head" ? "Team Head" : teams[0].role.roleName === "Member" ? "Team Member" : teams[0].role.roleName, ")", " "), " ", /*#__PURE__*/React.createElement("div", {
      className: "employee-span-no-project-team-add-more-text"
    }, "+", teams.length - 1, " more"))), /*#__PURE__*/React.createElement(Dropdown.Menu, {
      className: "employee-page-accordion-div-collapse-whole-div"
    }, /*#__PURE__*/React.createElement("div", {
      className: "employee-page-accordion-div-collapse"
    }, teams.map(function (t) {
      return /*#__PURE__*/React.createElement("div", {
        className: "employee-teams-list-bullet"
      }, /*#__PURE__*/React.createElement("div", {
        className: "employee-teams-list-bullet-dot"
      }), /*#__PURE__*/React.createElement("div", null, t.team.teamName, " (", t.role.roleName === "Head" ? "Team Head" : t.role.roleName === "Member" ? "Team Member" : t.role.roleName, ")"));
    }))))) : /*#__PURE__*/React.createElement("td", {
      className: "Employees-root-content-data-name-div-width"
    }, /*#__PURE__*/React.createElement(Dropdown, {
      open: isNavClick,
      className: classNames("employee-team-list-button .btn-primary")
    }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
      id: "dropdown-basics"
    }, /*#__PURE__*/React.createElement("span", {
      className: "employee-span"
    }, (_teams2 = teams) === null || _teams2 === void 0 ? void 0 : _teams2.length, " ", ((_teams3 = teams) === null || _teams3 === void 0 ? void 0 : _teams3.length) == 1 ? "team" : "teams")), /*#__PURE__*/React.createElement(Dropdown.Menu, {
      className: "employee-page-accordion-div-collapse-whole-div"
    }, /*#__PURE__*/React.createElement("div", {
      className: "employee-page-accordion-div-collapse"
    }, teams.map(function (t) {
      return /*#__PURE__*/React.createElement("div", {
        className: "employee-teams-list-bullet"
      }, /*#__PURE__*/React.createElement("div", {
        className: "employee-teams-list-bullet-dot"
      }), /*#__PURE__*/React.createElement("div", null, t.team.teamName, " (", t.role.roleName === "Head" ? "Team Head" : t.role.roleName === "Member" ? "Team Member" : t.role.roleName, ")"));
    }))))), organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.projectManagementFeature ? /*#__PURE__*/React.createElement("td", {
      className: "Employees-root-content-data-details-td-billable-rate"
    }, /*#__PURE__*/React.createElement("div", {
      className: "Employees-root-content-data-details-td-billable-div"
    }, /*#__PURE__*/React.createElement("div", {
      className: "Employees-root-content-data-details-td-billable"
    }, billableRate ? "".concat(currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R" : currenciesData == "SEK" ? "kr" : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM" : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs" : "$").concat(billableRate) : " ".concat(currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R" : currenciesData == "SEK" ? "kr" : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM" : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs" : "$", "0")), /*#__PURE__*/React.createElement("span", {
      className: "Employees-root-content-data-details-td-billable-text",
      onClick: function onClick() {
        return handleShowForbillableSettings(userId, billableRate, displayName, billableRateType);
      }
    }, "Change"))) : null, organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.projectManagementFeature ? /*#__PURE__*/React.createElement("td", {
      className: "Employees-root-content-data-details-td-billable-rate"
    }, /*#__PURE__*/React.createElement("div", {
      className: "Employees-root-content-data-details-td-billable-div"
    }, /*#__PURE__*/React.createElement("div", {
      className: "Employees-root-content-data-details-td-billable"
    }, labourCost ? "".concat(currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R" : currenciesData == "SEK" ? "kr" : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM" : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs" : "$").concat(labourCost) : " ".concat(currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R" : currenciesData == "SEK" ? "kr" : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM" : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs" : "$", "0")), /*#__PURE__*/React.createElement("span", {
      className: "Employees-root-content-data-details-td-billable-text",
      onClick: function onClick() {
        return handleShowForLabourCostSettings(userId, labourCost, displayName, labourCostType);
      }
    }, "Change"))) : null, type === "active" && isDemoOrLiveSite !== "demo" ? /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ActionMenuWithButton, {
      organisationCreatedBy: organisationCreatedBy,
      planId: planId,
      employeeUserId: userId,
      userUserId: user === null || user === void 0 ? void 0 : user.userId,
      passwordStatus: passwordStatus,
      userId: userId,
      displayName: displayName,
      handleLogoutAllDevices: handleLogoutAllDevices,
      resentLink: function resentLink() {
        return _resentLink(userId);
      },
      onDelete: function onDelete() {
        return _onDelete(userId);
      },
      onEdit: function onEdit() {
        return handleShow({
          appIcon: appIcon,
          appVersion: appVersion,
          billableRate: billableRate,
          displayName: displayName,
          email: email,
          labourCost: labourCost,
          organisationCreatedBy: organisationCreatedBy,
          passwordStatus: passwordStatus,
          profileUrl: profileUrl,
          status: status,
          teams: teams,
          uniqueUrl: uniqueUrl,
          userId: userId,
          employeeId: employeeId,
          dateOfBirth: dateOfBirth,
          dateOfJoining: dateOfJoining,
          designation: designation
        });
      },
      onSetting: function onSetting() {
        return handleShowForSettings({
          userId: userId,
          userRole: userRole
        });
      },
      deleteProps: {
        title: "Delete employee",
        buttonText: "Delete",
        message: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h6", {
          className: "font-weight-bold mb-2"
        }, "Are you sure to deactivate this user?"), /*#__PURE__*/React.createElement("p", {
          className: "text-secondary"
        }, "Tracking data associated with this account will be deleted."))
      },
      title: "Delete Task",
      buttonText: "Delete",
      text: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
        className: "font-weight-bold mb-2"
      }, "Are you surely want to delete this task?")),
      organisationSettings: organisationSettings,
      role: role
    })) : /*#__PURE__*/React.createElement("td", null));
  }), !((_employeeWithSearch = employeeWithSearch(employees)) !== null && _employeeWithSearch !== void 0 && _employeeWithSearch.length) ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: 8,
    className: "Employees-root-content-data-details text-center"
  }, "No employee found for \"".concat(search, "\"\n              "))) : null))) : /*#__PURE__*/React.createElement("div", {
    className: "text-center employees-root-content-data-details-no-employees"
  }, /*#__PURE__*/React.createElement("div", {
    colSpan: type === "active" ? 4 : 3,
    className: "text-secondary "
  }, "No ".concat(type, " employees."))), employees !== null && employees !== void 0 && employees.length ? /*#__PURE__*/React.createElement("div", {
    className: "task-overview-load-more-button"
  }, !isAllLoaded ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMore && !isLoadMoreButton ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMore();
    }
  }, "Load more")) : /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button project-management-miled-color"
  }, "You have seen all the employees")) : null);
});
var EmployeeFilter = function EmployeeFilter(props) {
  var teamsData = props.teamsData,
    teamsLoading = props.teamsLoading,
    roleParameterCheck = props.roleParameterCheck,
    setRoleParameterCheck = props.setRoleParameterCheck,
    teamParameterCheck = props.teamParameterCheck,
    setTeamParameterCheck = props.setTeamParameterCheck,
    osParameterCheck = props.osParameterCheck,
    setOsParameterCheck = props.setOsParameterCheck,
    appVersionParameterCheck = props.appVersionParameterCheck,
    setAppVersionParameterCheck = props.setAppVersionParameterCheck,
    appVersionList = props.appVersionList;
  var _React$useState23 = React.useState([{
      label: "All Teams",
      value: "all"
    }]),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    teamList = _React$useState24[0],
    setTeamList = _React$useState24[1];
  var _React$useState25 = React.useState([{
      label: "All App Versions",
      value: "all"
    }]),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    appVersionDetails = _React$useState26[0],
    setAppVersionDetails = _React$useState26[1];
  var roleDetails = [{
    label: "All Roles",
    value: "all"
  }, {
    label: "Admin",
    value: "24e4b513-da16-44e8-92ff-d28fcdc0d17f"
  }, {
    label: "Team Head",
    value: "af0b3d12-c49c-4c22-98fe-222f67bc893b"
  }, {
    label: "Team Member",
    value: "d1b69b7b-5eb7-4503-9947-d338a093533a"
  }];
  var osDetails = [{
    label: "All OS",
    value: "all"
  }, {
    label: "Mac",
    value: "Mac"
  }, {
    label: "Windows",
    value: "Windows"
  }, {
    label: "Linux",
    value: "Linux"
  }];
  React.useEffect(function () {
    if (!(teamsData !== null && teamsData !== void 0 && teamsData.organisationTeams)) return;
    var teams = teamsData.organisationTeams.map(function (_ref7) {
      var teamName = _ref7.teamName,
        teamId = _ref7.teamId;
      return {
        label: teamName,
        value: teamId
      };
    });
    setTeamList([{
      label: "All Teams",
      value: "all"
    }].concat(_toConsumableArray(teams)));
  }, [teamsData]);

  // React.useEffect(() => {
  //   if (!appVersionList) return;

  //   const temp = appVersionList.map((version) => ({
  //     label: version,
  //     value: version,
  //   }));

  //   setAppVersionDetails([{ label: "All App Versions", value: "all" }, ...temp]);
  // }, [appVersionList]);

  return /*#__PURE__*/React.createElement("div", {
    className: "summary-report-details-content-report-type-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "employee-details-content-report-type"
  }, /*#__PURE__*/React.createElement("label", {
    className: "summary-report-details-label"
  }, "Role"), /*#__PURE__*/React.createElement("div", {
    className: "emplyee-header-details-filter-user"
  }, /*#__PURE__*/React.createElement(Select, {
    value: roleParameterCheck,
    onChange: function onChange(selected) {
      return setRoleParameterCheck(selected || []);
    },
    options: roleDetails,
    className: "summary-report-details-filter-team-select",
    classNamePrefix: "Filter By User",
    placeholder: "Filter By User"
    // isClearable
  }))), /*#__PURE__*/React.createElement("div", {
    className: "employee-details-content-report-type"
  }, /*#__PURE__*/React.createElement("label", {
    className: "summary-report-details-label"
  }, "Team"), /*#__PURE__*/React.createElement("div", {
    className: "emplyee-header-details-filter-user"
  }, /*#__PURE__*/React.createElement(Select, {
    value: teamParameterCheck,
    onChange: function onChange(selected) {
      return setTeamParameterCheck(selected || []);
    },
    options: teamList,
    className: "summary-report-details-filter-team-select",
    classNamePrefix: "Filter By User",
    placeholder: "Filter By User"
    // isClearable
  }))), /*#__PURE__*/React.createElement("div", {
    className: "employee-details-content-report-type"
  }, /*#__PURE__*/React.createElement("label", {
    className: "summary-report-details-label"
  }, "OS"), /*#__PURE__*/React.createElement("div", {
    className: "emplyee-header-details-filter-user"
  }, /*#__PURE__*/React.createElement(Select, {
    value: osParameterCheck,
    onChange: function onChange(selected) {
      return setOsParameterCheck(selected || []);
    },
    options: osDetails,
    className: "summary-report-details-filter-team-select",
    classNamePrefix: "Filter By User",
    placeholder: "Filter By User"
    // isClearable
  }))));
};
var MobileViewTable = function MobileViewTable(props) {
  var _employeeWithSearch2;
  var type = props.type,
    employeeWithSearch = props.employeeWithSearch,
    isDemoOrLiveSite = props.isDemoOrLiveSite,
    _resentLink2 = props.resentLink,
    _onDelete2 = props.onDelete,
    handleShow = props.handleShow,
    employees = props.employees,
    handleShowForSettings = props.handleShowForSettings,
    planId = props.planId,
    organisationSettings = props.organisationSettings,
    handleShowForbillableSettings = props.handleShowForbillableSettings,
    user = props.user,
    editUserData = props.editUserData,
    deleteUserData = props.deleteUserData,
    role = props.role;
  return /*#__PURE__*/React.createElement(Table, {
    borderless: true,
    hover: true,
    className: "Employees-root-content-table"
  }, /*#__PURE__*/React.createElement("thead", {
    className: "Employees-root-content-data-header"
  }, /*#__PURE__*/React.createElement("tr", null, MobileViewColumnNameList.map(function (columnName) {
    return /*#__PURE__*/React.createElement("th", {
      key: columnName
    }, columnName);
  }), type === "active" ? /*#__PURE__*/React.createElement("th", null) : null)), /*#__PURE__*/React.createElement("tbody", null, employeeWithSearch(employees).map(function (employee) {
    var profileUrl = employee.profileUrl,
      displayName = employee.displayName,
      passwordStatus = employee.passwordStatus,
      uniqueUrl = employee.uniqueUrl,
      appVersion = employee.appVersion,
      appIcon = employee.appIcon,
      email = employee.email,
      userId = employee.userId,
      teams = employee.teams,
      billableRate = employee.billableRate,
      labourCost = employee.labourCost,
      organisationCreatedBy = employee.organisationCreatedBy,
      status = employee.status,
      billableRateType = employee.billableRateType,
      labourCostType = employee.labourCostType,
      userRole = employee.userRole,
      dateOfBirth = employee.dateOfBirth,
      dateOfJoining = employee.dateOfJoining,
      designation = employee.designation;
    if (deleteUserData.length > 0 && deleteUserData.includes(userId)) {
      return;
    }
    var findEditUserId = editUserData.find(function (user) {
      return user.userId === userId;
    }) || {};
    if (editUserData.length !== 0 && Object.keys(findEditUserId).length > 0) {
      displayName = findEditUserId.displayName;
      email = findEditUserId.email;
      profileUrl = findEditUserId.profileUrl;
      teams = (findEditUserId === null || findEditUserId === void 0 ? void 0 : findEditUserId.teams) || teams;
      uniqueUrl = findEditUserId.uniqueUrl;
      userId = findEditUserId.userId;
      billableRate = (findEditUserId === null || findEditUserId === void 0 ? void 0 : findEditUserId.billableRate) || billableRate;
      labourCost = (findEditUserId === null || findEditUserId === void 0 ? void 0 : findEditUserId.labourCost) || labourCost;
      billableRateType = (findEditUserId === null || findEditUserId === void 0 ? void 0 : findEditUserId.billableRateType) || billableRateType;
      labourCostType = (findEditUserId === null || findEditUserId === void 0 ? void 0 : findEditUserId.labourCostType) || labourCostType;
    }
    {
      var _displayName2;
      profileUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "employee-card-avatar-profile"
      }, /*#__PURE__*/React.createElement("img", {
        alt: "Workfolio",
        src: profileUrl,
        className: "team-card-avatar-profile-img"
      }))) : /*#__PURE__*/React.createElement("div", {
        className: "team-card-avatar"
      }, (_displayName2 = displayName) === null || _displayName2 === void 0 ? void 0 : _displayName2.charAt(0));
    }
    return /*#__PURE__*/React.createElement("tr", {
      key: userId
      //className="Employees-root-content-data-details"
      ,
      className: classNames("Employees-root-content-data-details", {
        "Employees-root-content-data-details-passwors-status": passwordStatus === false
      })
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "Employees-root-content-data-details-avatar"
    }, profileUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "employee-card-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Workfolio",
      src: profileUrl,
      className: "team-card-avatar-profile-img"
    }))) : /*#__PURE__*/React.createElement("div", {
      className: "Employees-root-content-data-details-avatar-circle text-white"
    }, displayName.charAt(0)), /*#__PURE__*/React.createElement("div", {
      className: "Employees-root-content-data-details-name-data"
    }, /*#__PURE__*/React.createElement("div", {
      //className="Employees-root-content-data-details-name-data-team-name"
      className: classNames("Employees-root-content-data-details-name-data-team-name", {
        "employee-page-name-password-status": passwordStatus === false
      })
    }, displayName), passwordStatus === true ? /*#__PURE__*/React.createElement("div", {
      className: "employee-page-mobile-email-id"
    }, email) : /*#__PURE__*/React.createElement("div", {
      className: "employee-page-password-status"
    }, "Yet to accept the invite")))), type === "active" && isDemoOrLiveSite !== "demo" ? /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ActionMenu, {
      organisationCreatedBy: organisationCreatedBy,
      employeeUserId: userId,
      passwordStatus: passwordStatus,
      planId: planId,
      resentLink: function resentLink() {
        return _resentLink2(userId);
      },
      onDelete: function onDelete() {
        return _onDelete2(userId);
      },
      onEdit: function onEdit() {
        return handleShow({
          appIcon: appIcon,
          appVersion: appVersion,
          billableRate: billableRate,
          displayName: displayName,
          email: email,
          labourCost: labourCost,
          organisationCreatedBy: organisationCreatedBy,
          passwordStatus: passwordStatus,
          profileUrl: profileUrl,
          status: status,
          teams: teams,
          uniqueUrl: uniqueUrl,
          userId: userId,
          dateOfBirth: dateOfBirth,
          dateOfJoining: dateOfJoining,
          designation: designation
        });
      },
      onSetting: function onSetting() {
        return handleShowForSettings({
          userId: userId,
          userRole: userRole
        });
      },
      deleteProps: {
        title: "Delete employee",
        buttonText: "Delete",
        message: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h6", {
          className: "font-weight-bold mb-2"
        }, "Are you sure to deactivate this user?"), /*#__PURE__*/React.createElement("p", {
          className: "text-secondary"
        }, "You won't be able to re-activate this user but still you can access the user's data anytime."))
      },
      title: "Delete Task",
      buttonText: "Delete",
      text: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
        className: "font-weight-bold mb-2"
      }, "Are you surely want to delete this task?")),
      organisationSettings: organisationSettings,
      onBillableRate: function onBillableRate() {
        return handleShowForbillableSettings(userId, billableRate, displayName);
      },
      userUserId: user === null || user === void 0 ? void 0 : user.userId,
      role: role
    })) : null);
  }), !((_employeeWithSearch2 = employeeWithSearch(employees)) !== null && _employeeWithSearch2 !== void 0 && _employeeWithSearch2.length) ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: 8,
    className: "Employees-root-content-data-details text-center"
  }, "No employee found for \"".concat(search, "\"\n              "))) : null));
};
var ActionMenu = function ActionMenu(props) {
  var _user;
  var resentLink = props.resentLink,
    onEdit = props.onEdit,
    onDelete = props.onDelete,
    _props$Icon = props.Icon,
    Icon = _props$Icon === void 0 ? HiOutlineDotsVertical : _props$Icon,
    deleteProps = props.deleteProps,
    passwordStatus = props.passwordStatus,
    onSetting = props.onSetting,
    organisationCreatedBy = props.organisationCreatedBy,
    employeeUserId = props.employeeUserId,
    userUserId = props.userUserId,
    planId = props.planId,
    organisationSettings = props.organisationSettings,
    role = props.role;
  var _React$useState27 = React.useState(false),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    showConfirmation = _React$useState28[0],
    setShowConfirmation = _React$useState28[1];
  var handleClose = function handleClose() {
    return setShowConfirmation(false);
  };
  var handleOpen = function handleOpen() {
    return setShowConfirmation(true);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dropdown, {
    className: "action-menu"
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    variant: "light",
    id: "dropdown-basic"
  }, /*#__PURE__*/React.createElement(Icon, null)), /*#__PURE__*/React.createElement(Dropdown.Menu, {
    menuAlign: "right"
  }, passwordStatus === false ? /*#__PURE__*/React.createElement(Dropdown.Item, {
    className: "text-primary manage-employee-resent-invite-link",
    onClick: resentLink
  }, "Resend Invite Link") : null, organisationCreatedBy !== employeeUserId && userUserId !== employeeUserId ? /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: onEdit
  }, "Edit Profile") : null, planId === "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to edit track settings")
  }, /*#__PURE__*/React.createElement(Dropdown.Item, null, "Edit Track Settings")) : role == "Admin" || role == "Head" && ((_user = user) === null || _user === void 0 ? void 0 : _user.userId) != userId ? /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: onSetting
  }, "Edit Track Settings") : null, organisationCreatedBy !== employeeUserId && userUserId !== employeeUserId ? /*#__PURE__*/React.createElement(Dropdown.Item, {
    className: "text-danger",
    onClick: handleOpen
  }, "Delete") : null)), /*#__PURE__*/React.createElement(DeleteConfirmation, _extends({
    show: showConfirmation,
    onClose: handleClose,
    onOk: onDelete
  }, deleteProps)));
};
var ActionMenuWithButton = function ActionMenuWithButton(props) {
  var resentLink = props.resentLink,
    onEdit = props.onEdit,
    onDelete = props.onDelete,
    _props$Icon2 = props.Icon,
    Icon = _props$Icon2 === void 0 ? HiOutlineDotsVertical : _props$Icon2,
    deleteProps = props.deleteProps,
    passwordStatus = props.passwordStatus,
    onSetting = props.onSetting,
    organisationCreatedBy = props.organisationCreatedBy,
    employeeUserId = props.employeeUserId,
    userUserId = props.userUserId,
    planId = props.planId,
    organisationSettings = props.organisationSettings,
    role = props.role,
    userId = props.userId,
    displayName = props.displayName,
    handleLogoutAllDevices = props.handleLogoutAllDevices;
  var _React$useState29 = React.useState(false),
    _React$useState30 = _slicedToArray(_React$useState29, 2),
    showConfirmation = _React$useState30[0],
    setShowConfirmation = _React$useState30[1];
  var handleClose = function handleClose() {
    return setShowConfirmation(false);
  };
  var handleOpen = function handleOpen() {
    return setShowConfirmation(true);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "employee-page-edit-profile-text-td"
  }, role == "Admin" || organisationCreatedBy !== employeeUserId && userUserId !== employeeUserId ? /*#__PURE__*/React.createElement("div", {
    className: "employee-page-edit-profile-text-td-table-data-icon-div",
    onClick: onEdit
  }, /*#__PURE__*/React.createElement(MdModeEdit, {
    className: "employee-page-edit-profile-text-td-data-edit-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "employee-page-edit-profile-text-td-edit-text"
  }, "Edit")) : /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "The ".concat(role == "Admin" ? "admin" : "head", " account cannot be edited."))
  }, /*#__PURE__*/React.createElement("div", {
    className: "employee-page-edit-profile-text-td-table-data-icon-div"
  }, /*#__PURE__*/React.createElement(MdModeEdit, {
    className: "employee-page-edit-profile-text-td-data-edit-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "employee-page-edit-profile-text-td-edit-text"
  }, "Edit"))), organisationCreatedBy !== employeeUserId && userUserId !== employeeUserId ? /*#__PURE__*/React.createElement("div", {
    className: "employee-page-edit-profile-text-td-table-data-icon-div",
    onClick: handleOpen
  }, /*#__PURE__*/React.createElement(MdDeleteForever, {
    className: "employee-page-edit-profile-text-td-data-edit-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "employee-page-edit-profile-text-td-edit-text"
  }, "Delete")) : /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "The ".concat(role == "Admin" ? "admin" : "head", " account cannot be deleted."))
  }, /*#__PURE__*/React.createElement("div", {
    className: "employee-page-edit-profile-text-td-table-data-icon-div"
  }, /*#__PURE__*/React.createElement(MdDeleteForever, {
    className: "employee-page-edit-profile-text-td-data-edit-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "employee-page-edit-profile-text-td-edit-text"
  }, "Delete"))), role == "Admin" ? /*#__PURE__*/React.createElement(Dropdown, {
    className: "employee-list-edit-menus"
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    variant: "success",
    id: "dropdown-basic"
  }, /*#__PURE__*/React.createElement(HiOutlineDotsVertical, {
    className: "employee-list-edit-menus-icon"
  })), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: function onClick() {
      return handleLogoutAllDevices(userId, displayName, userUserId);
    }
  }, "Logout from all devices"))) : null), /*#__PURE__*/React.createElement(DeleteConfirmation, _extends({
    show: showConfirmation,
    onClose: handleClose,
    onOk: onDelete
  }, deleteProps)));
};
var DeleteConfirmation = function DeleteConfirmation(props) {
  var show = props.show,
    onClose = props.onClose,
    title = props.title,
    onOk = props.onOk,
    message = props.message,
    buttonText = props.buttonText;
  var onAgree = function onAgree() {
    onOk();
    onClose();
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    onHide: onClose
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, title || "Alert")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, message), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: onClose
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "danger",
    className: "project-details-task-card-delete-button",
    onClick: onAgree
  }, buttonText)));
};
var handleEditUserCache = function handleEditUserCache(organisationId, teamId, role, search) {
  return function (cache, editResponse) {
    var _editResponse$data;
    var editedUser = editResponse === null || editResponse === void 0 ? void 0 : (_editResponse$data = editResponse.data) === null || _editResponse$data === void 0 ? void 0 : _editResponse$data.editUser;
    if (!editedUser) return;
    var _cache$readQuery = cache.readQuery({
        query: ORGANISATION_USERS_QUERY,
        variables: {
          organisationId: organisationId,
          teamId: teamId,
          userRole: role,
          limit: LIMIT,
          offset: 0,
          searchText: search
        }
      }),
      organisationUsers = _cache$readQuery.organisationUsers;
    var editedOrganisationUsers = organisationUsers.map(function (u) {
      if (u.userId === editedUser.userId) {
        return editedUser;
      }
      return u;
    });
    cache.writeQuery({
      query: ORGANISATION_USERS_QUERY,
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userRole: role,
        limit: LIMIT,
        offset: 0,
        searchText: search
      },
      data: {
        organisationUsers: editedOrganisationUsers
      }
    });
  };
};
var EditEmployee = /*#__PURE__*/React.memo(function NewEmployeeModal(props) {
  var employeeDetails = props.employeeDetails,
    handleClose = props.handleClose,
    roles = props.roles,
    teams = props.teams,
    teamId = props.teamId,
    role = props.role,
    editUserData = props.editUserData,
    setEditUserData = props.setEditUserData,
    user = props.user,
    setUser = props.setUser,
    tabData = props.tabData,
    setTabData = props.setTabData;
  var _useState17 = useState(true),
    _useState18 = _slicedToArray(_useState17, 2),
    addTeamButton = _useState18[0],
    setAddTeamButton = _useState18[1];
  var _React$useContext4 = React.useContext(FilterContext),
    organisationId = _React$useContext4.organisationId;
  var _React$useContext5 = React.useContext(SearchContext),
    search = _React$useContext5.search;
  var _React$useState31 = React.useState(null),
    _React$useState32 = _slicedToArray(_React$useState31, 2),
    dOJDate = _React$useState32[0],
    setDOJDate = _React$useState32[1];
  var _React$useState33 = React.useState(null),
    _React$useState34 = _slicedToArray(_React$useState33, 2),
    dOBDate = _React$useState34[0],
    setDOBDate = _React$useState34[1];
  var _useMutation7 = useMutation(EDIT_USER_MUTATION),
    _useMutation8 = _slicedToArray(_useMutation7, 2),
    editUser = _useMutation8[0],
    editing = _useMutation8[1].loading;
  function isNumber(value) {
    return Number.isFinite(value);
  }
  var onEditUsers = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(values, actions) {
      var displayName, email, teams, employeeId, designation, teamIdCount, duplicates, response, _editUser, findEditUserId, findOrganisationUserId;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (!editing) {
              _context4.next = 2;
              break;
            }
            return _context4.abrupt("return");
          case 2:
            displayName = values.displayName, email = values.email, teams = values.teams, employeeId = values.employeeId, designation = values.designation;
            teamIdCount = {};
            duplicates = [];
            teams.forEach(function (team) {
              teamIdCount[team.teamId] = (teamIdCount[team.teamId] || 0) + 1;
            });

            // Find all objects with duplicate `team_id`
            teams.forEach(function (team) {
              if (teamIdCount[team.teamId] > 1) {
                duplicates.push(team);
              }
            });
            if (!duplicates.length) {
              _context4.next = 10;
              break;
            }
            actions.setFieldError("formError", "Team Name must be unique!");
            return _context4.abrupt("return", false);
          case 10:
            _context4.prev = 10;
            _context4.next = 13;
            return editUser({
              variables: {
                user: {
                  displayName: displayName,
                  email: email,
                  teams: teams,
                  employeeId: employeeId,
                  designation: designation,
                  dOJDate: isNumber(dOJDate) ? moment(dOJDate) : dOJDate,
                  dOBDate: isNumber(dOBDate) ? moment(dOBDate) : dOBDate
                },
                userId: values.userId,
                organisationId: organisationId
              },
              refetchQueries: [{
                query: ORGANISATION_TEAMS_AND_ROLE_QUERY,
                variables: {
                  organisationId: organisationId
                }
              }, {
                query: TEAM_DETAILS_QUERY,
                variables: {
                  organisationId: organisationId
                }
              }]
              //update: handleEditUserCache(organisationId, teamId, role, search),
            });
          case 13:
            response = _context4.sent;
            if (response || response.data || response.data.editUser) {
              _editUser = editUserData;
              findEditUserId = _editUser.find(function (user) {
                return user.userId === response.data.editUser.userId;
              }) || {};
              if (Object.keys(findEditUserId).length > 0) {
                _editUser = _editUser.filter(function (val) {
                  //callback function
                  if (val.userId !== response.data.editUser.userId) {
                    //filtering criteria
                    return val;
                  }
                });
              }
              _editUser.push(response.data.editUser);
              setEditUserData(_editUser);
              findOrganisationUserId = _editUser.find(function (userTemp) {
                return userTemp.userId === user.userId;
              }) || {};
              if (user.userId == findOrganisationUserId.userId) {
                setUser(_objectSpread(_objectSpread({}, user), {}, {
                  displayName: findOrganisationUserId.displayName,
                  emailId: findOrganisationUserId.email
                }));
              }
            }
            handleClose();
            toast.success("Employee updated successfully!");
            _context4.next = 22;
            break;
          case 19:
            _context4.prev = 19;
            _context4.t0 = _context4["catch"](10);
            // A 429 is an Apollo network error, so its reason never reaches
            // error.message and would land in the generic branch below.
            if (isRateLimited(_context4.t0)) {
              actions.setFieldError("formError", "Too many user changes in a short time. Please try again in an hour.");
            } else if (_context4.t0.message.includes("User with the email already exists")) {
              actions.setFieldError("email", "User with the email already exists");
            } else {
              actions.setFieldError("formError", "Something went wrong! Please try again later.");
            }
          case 22:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[10, 19]]);
    }));
    return function onEditUsers(_x6, _x7) {
      return _ref8.apply(this, arguments);
    };
  }();
  var employeeValues = React.useMemo(function () {
    if (!employeeDetails) return null;
    var displayName = employeeDetails.displayName,
      email = employeeDetails.email,
      teams = employeeDetails.teams,
      userId = employeeDetails.userId,
      employeeId = employeeDetails.employeeId,
      designation = employeeDetails.designation;
    var adminCheck = true;
    teams.forEach(function (o2) {
      var _o2$role;
      if (((_o2$role = o2.role) === null || _o2$role === void 0 ? void 0 : _o2$role.roleId) !== "24e4b513-da16-44e8-92ff-d28fcdc0d17f") {
        adminCheck = false;
      }
    });
    if (adminCheck) {
      setAddTeamButton(false);
    } else {
      setAddTeamButton(true);
    }
    //console.log("adminCheck",adminCheck);

    return {
      displayName: displayName,
      email: email,
      employeeId: employeeId == null ? "" : employeeId,
      teams: adminCheck ? [{
        teamId: "allTeam",
        roleId: "24e4b513-da16-44e8-92ff-d28fcdc0d17f"
      }] : teams.map(function (t) {
        var _t$team, _t$role;
        return {
          teamId: (_t$team = t.team) === null || _t$team === void 0 ? void 0 : _t$team.teamId,
          roleId: (_t$role = t.role) === null || _t$role === void 0 ? void 0 : _t$role.roleId
        };
      }),
      //teams: teams.map((t) => ({ teamId: t.team?.teamId , roleId: t.role?.roleId })),
      designation: designation ? designation : "",
      userId: userId
    };
  }, [employeeDetails]);
  React.useEffect(function () {
    if (employeeDetails) {
      setDOJDate(employeeDetails && employeeDetails.dateOfJoining ? Number(employeeDetails.dateOfJoining) : null);
      setDOBDate(employeeDetails && employeeDetails.dateOfBirth ? Number(employeeDetails.dateOfBirth) : null);
    }
  }, [employeeDetails]);
  if (!employeeDetails) {
    return null;
  }
  var organisationCreatedBy = employeeDetails.organisationCreatedBy;
  var employeeUserId = employeeDetails.userId;
  var userUserId = user.userId;
  var handleTabSelect = function handleTabSelect(key) {
    setTabData(key);
  };

  // const handleDOJChange = (e) => {
  //   setTaskStartDate(e);
  // };

  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleClose,
    centered: true,
    size: "lg",
    contentClassName: "new-employee-modal"
  }, /*#__PURE__*/React.createElement("div", {
    className: "employee-edit-password"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, null, tabData == "edit" ? "Edit Employee" : "Change Password for ".concat(employeeDetails.displayName))), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(Tabs, {
    defaultActiveKey: "edit",
    onSelect: function onSelect(e) {
      handleTabSelect(e);
    }
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "edit",
    title: "Edit Profile"
  }, /*#__PURE__*/React.createElement(Formik, {
    onSubmit: onEditUsers,
    initialValues: employeeValues,
    validationSchema: UserSchema
  }, function (_ref9) {
    var values = _ref9.values,
      errors = _ref9.errors,
      touched = _ref9.touched,
      isSubmitting = _ref9.isSubmitting,
      setFieldError = _ref9.setFieldError;
    var emailError = errorMessage(errors, touched, "email");
    ///const emailAlreadyError = errorMessage(errors, touched, "email");
    var displayNameError = errorMessage(errors, touched, "displayName");
    var employeeIdError = errorMessage(errors, touched, "employeeId");
    var designationError = errorMessage(errors, touched, "designation");
    var dojError = errorMessage(errors, touched, "dateOfJoining");
    var dobError = errorMessage(errors, touched, "dateOfBirth");
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement("h4", {
      className: "text-dark mb-3"
    }), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      sm: 6,
      className: "mb-2 pr-sm-4"
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
      className: "add-employee-modal-form-employee-label-name"
    }, "Employee Email", " ", /*#__PURE__*/React.createElement("span", {
      "class": "add-employee-modal-form-employee-label-name-required"
    }, " *")), emailError, /*#__PURE__*/React.createElement(Field, {
      as: Form.Control,
      className: "add-employee-modal-form-employee-input",
      name: "email",
      type: "email",
      required: true,
      placeholder: "Enter employee email",
      isInvalid: emailError != null
    }))), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      sm: 6,
      className: "mb-2"
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
      className: "add-employee-modal-form-employee-label-name"
    }, "Employee Name", " ", /*#__PURE__*/React.createElement("span", {
      "class": "add-employee-modal-form-employee-label-name-required"
    }, " *")), /*#__PURE__*/React.createElement(Field, {
      as: Form.Control,
      className: "add-employee-modal-form-employee-input",
      name: "displayName",
      type: "text",
      required: true,
      placeholder: "Enter employee name",
      isInvalid: displayNameError != null
    }), displayNameError))), /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      sm: 6,
      className: "mb-2  pr-sm-4"
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
      className: "add-employee-modal-form-employee-label-name"
    }, "Employee ID", " ", /*#__PURE__*/React.createElement("span", {
      className: "add-employee-modal-form-employee-id-label"
    }, "(Optional)")), /*#__PURE__*/React.createElement(Field, {
      as: Form.Control,
      className: "add-employee-modal-form-employee-input",
      name: "employeeId",
      type: "text",
      placeholder: "Enter Employee Id",
      isInvalid: employeeIdError != null
    }), employeeIdError)), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      sm: 6,
      className: "mb-2"
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
      className: "add-employee-modal-form-employee-label-name"
    }, "Designation", " ", /*#__PURE__*/React.createElement("span", {
      className: "add-employee-modal-form-employee-id-label"
    }, "(Optional)")), /*#__PURE__*/React.createElement(Field, {
      as: Form.Control,
      className: "add-employee-modal-form-employee-input",
      name: "designation",
      type: "text",
      placeholder: "Enter designation",
      isInvalid: designationError != null
    }), designationError))), /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      sm: 6,
      className: "mb-2  pr-sm-4"
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
      className: "add-employee-modal-form-employee-label-name"
    }, "Date of Joining", " ", /*#__PURE__*/React.createElement("span", {
      className: "add-employee-modal-form-employee-id-label"
    }, "(Optional)")), /*#__PURE__*/React.createElement(DatePicker, {
      id: "employee-date-of-joining"
      // className="add-employee-modal-form-employee-input"
      ,
      dateFormat: "dd MMM, yyyy",
      selected: dOJDate,
      onChange: function onChange(e) {
        return setDOJDate(e);
      },
      isClearable: true,
      className: "add-employee-modal-form-employee-input task-details-due-date-date-picker add-employee-modal-form-employee-input-date",
      placeholderText: "Select date of joining",
      autoComplete: "off",
      showMonthDropdown: true,
      showYearDropdown: true
      // open={isManualDatePickerOpen}
      // inline
    }), dojError)), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      sm: 6,
      className: "mb-2"
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
      className: "add-employee-modal-form-employee-label-name"
    }, "Date of Birth", " ", /*#__PURE__*/React.createElement("span", {
      className: "add-employee-modal-form-employee-id-label"
    }, "(Optional)")), /*#__PURE__*/React.createElement(DatePicker, {
      id: "employee-date-of-birth"
      // className="add-employee-modal-form-employee-input"
      ,
      dateFormat: "dd MMM, yyyy",
      selected: dOBDate,
      onChange: function onChange(e) {
        return setDOBDate(e);
      },
      isClearable: true,
      className: "task-details-due-date-date-picker add-employee-modal-form-employee-input",
      placeholderText: "Select date of birth",
      autoComplete: "off",
      showMonthDropdown: true,
      showYearDropdown: true
      // open={isManualDatePickerOpen}
      // inline
    }), dobError))), /*#__PURE__*/React.createElement("div", {
      className: "add-employee-modal-form-employee-team-details"
    }, role !== "Head" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldArray, {
      name: "teams",
      render: function render(arrayHelpers) {
        //console.log("values.teams",values.teams);
        return /*#__PURE__*/React.createElement(React.Fragment, null, values.teams.map(function (_team, index) {
          var roleIdError = errorMessage(errors, touched, "teams[".concat(index, "].roleId"));
          var teamIdError = errorMessage(errors, touched, "teams[".concat(index, "].teamId"));
          return /*#__PURE__*/React.createElement(Form.Row, {
            key: "user-".concat(index)
          }, /*#__PURE__*/React.createElement(Col, {
            xs: 12,
            sm: 5,
            className: "mb-2 pr-sm-4"
          }, /*#__PURE__*/React.createElement(Field, {
            name: "teams[".concat(index, "].teamId")
          }, function (_ref10) {
            var field = _ref10.field,
              form = _ref10.form,
              meta = _ref10.meta;
            // console.log("team Index",teams[index]);
            // console.log(" teams[index].roleId ",teams[index].roleId);
            return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
              className: "add-employee-modal-form-employee-label-name"
            }, "Team Name", " ", /*#__PURE__*/React.createElement("span", {
              "class": "add-employee-modal-form-employee-label-name-required"
            }, " ", "*")), teamIdError, /*#__PURE__*/React.createElement(Form.Control, _extends({
              as: "select",
              defaultValue: "",
              required: true
            }, field, {
              disabled: values.teams[index].roleId === "24e4b513-da16-44e8-92ff-d28fcdc0d17f" ? true : false,
              isInvalid: teamIdError != null,
              onChange: function onChange(e) {
                form.setFieldValue("teams[".concat(index, "].teamId"), e.target.value);
                var exists = teams.some(function (team) {
                  return team.teamId === e.target.value;
                });
                if (exists) {
                  form.setFieldError("teams[".concat(index, "].teamId"), "Team ID must be unique");
                  form.setFieldTouched("teams[".concat(index, "].teamId"), true, true);
                } else {
                  form.setFieldError("teams[".concat(index, "].teamId"), null); // Clear error
                  form.setFieldTouched("teams[".concat(index, "].teamId"), true, false);
                }
              }
            }), values.teams[index].roleId === "24e4b513-da16-44e8-92ff-d28fcdc0d17f" ? /*#__PURE__*/React.createElement("option", {
              value: "allTeam"
            }, "All Team") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("option", {
              value: ""
            }, "Team..."), teams.map(function (team) {
              return /*#__PURE__*/React.createElement("option", {
                value: team.teamId
              }, team.teamName);
            }))));
          })), /*#__PURE__*/React.createElement(Col, {
            xs: 9,
            sm: 4,
            className: "mb-2"
          }, /*#__PURE__*/React.createElement(Field, {
            name: "teams[".concat(index, "].roleId")
          }, function (_ref11) {
            var field = _ref11.field,
              form = _ref11.form;
            var onChange = field.onChange,
              restField = _objectWithoutProperties(field, _excluded);
            return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
              className: "add-employee-modal-form-employee-label-name"
            }, "Role", " ", /*#__PURE__*/React.createElement("span", {
              "class": "add-employee-modal-form-employee-label-name-required"
            }, " ", "*")), roleIdError, /*#__PURE__*/React.createElement(Form.Control, _extends({
              as: "select",
              defaultValue: "",
              required: true
              //{...field}
              ,
              disabled: role == "Admin" && (organisationCreatedBy == employeeUserId || userUserId == employeeUserId)
            }, restField, {
              onChange: function onChange(e) {
                form.setFieldValue("teams[".concat(index, "].roleId"), e.target.value);
                if (e.target.value === "24e4b513-da16-44e8-92ff-d28fcdc0d17f") {
                  form.setFieldValue("teams[".concat(index, "].teamId"), "allTeam");
                  form.setFieldValue("teams", [{
                    teamId: "allTeam",
                    roleId: "24e4b513-da16-44e8-92ff-d28fcdc0d17f"
                  }]);
                  setAddTeamButton(false);
                } else {
                  form.setFieldValue("teams[".concat(index, "].teamId"), values.teams[index].teamId);
                  setAddTeamButton(true);
                }
              },
              isInvalid: roleIdError != null
            }), /*#__PURE__*/React.createElement("option", {
              value: ""
            }, "Role..."), roles === null || roles === void 0 ? void 0 : roles.map(function (role) {
              return /*#__PURE__*/React.createElement("option", {
                value: role.roleId
              }, role.roleName === "Head" ? "Team Head" : role.roleName === "Member" ? "Team Member" : role.roleName);
            })));
          })), values.teams.length > 1 ? /*#__PURE__*/React.createElement(Col, {
            xs: 3,
            sm: 2,
            className: "mb-2 d-flex align-items-center justify-content-center"
          }, /*#__PURE__*/React.createElement(Button, {
            variant: "link",
            className: "mt-3",
            size: "sm",
            onClick: function onClick() {
              return arrayHelpers.remove(index);
            }
          }, "Remove")) : null);
        }), addTeamButton ? /*#__PURE__*/React.createElement(Button, {
          variant: "link",
          onClick: function onClick() {
            return arrayHelpers.push({
              teamId: "",
              roleId: ""
            });
          }
        }, "+ Add another team") : null);
      }
    }), typeof errors.teams === "string" && touched.teams && /*#__PURE__*/React.createElement("div", {
      className: "text-danger mt-1"
    }, errors.teams)) : null)), /*#__PURE__*/React.createElement(Modal.Footer, null, typeof errors.users === "string" ? /*#__PURE__*/React.createElement("div", {
      className: "form-error"
    }, errors.users) : null, errors.formError ? /*#__PURE__*/React.createElement("div", {
      className: "form-error"
    }, errors.formError) : null, /*#__PURE__*/React.createElement(Button, {
      variant: "light",
      onClick: handleClose,
      disabled: isSubmitting || editing
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      disabled: isSubmitting || editing,
      type: "submit"
    }, "Update")));
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "password",
    title: "Change Password"
  }, /*#__PURE__*/React.createElement(Password, {
    user: user,
    employeeUserId: employeeUserId,
    passwordStatus: employeeDetails.passwordStatus
  }))))));
});
var EmployeeSetting = function EmployeeSetting(props) {
  var _userWorkDayData$user, _userWorkDayData$user2, _userWorkDayData$user3, _userWorkDayData$user4, _userWorkDayData$user5, _workDaySettings$scre, _workDaySettings$blur, _workDaySettings$scre2, _workDaySettings$allo, _workDaySettings$allo2, _workDaySettings$allo3, _workDaySettings$allo4, _workDaySettings$idle, _workDaySettings$stea, _workDaySettings$orga, _workDaySettings$allo5, _workDaySettings$auto, _workDaySettings$keyS, _workDaySettings$mous, _workDaySettings$expe;
  var employeeUserId = props.employeeUserId,
    handleClose = props.handleClose,
    organisationId = props.organisationId,
    organisationSettings = props.organisationSettings,
    employeeUserRole = props.employeeUserRole,
    organisationBilling = props.organisationBilling;
  // const [startTime, setStartTime] = React.useState(moment());
  // const [endTime, setEndTime] = React.useState(moment());

  if (!employeeUserId) {
    return null;
  }
  var formikRef = React.useRef();

  // console.log({ organisationSettings?.workingDays });

  /** ADD WORK DAY SETTINGS FUNCTIONALITY **/
  var _useMutation9 = useMutation(ADD_USER_WORK_DAY_SETTINGS_MUTATION),
    _useMutation10 = _slicedToArray(_useMutation9, 2),
    addUserWorkDaySettings = _useMutation10[0],
    addUserWorkDaySettingsLoading = _useMutation10[1].loading;
  var _useMutation11 = useMutation(UPDATE_ORGANISATION_SETTINGS_FOR_USER_MUTATION),
    _useMutation12 = _slicedToArray(_useMutation11, 2),
    updateOrganisationSettingsForUser = _useMutation12[0],
    updateOrgSettingsLoading = _useMutation12[1].loading;
  var handleResetToOrganisationSettings = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var _response$errors, _response$data, response, _formikRef$current;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return updateOrganisationSettingsForUser({
              variables: {
                organisationId: organisationId,
                userId: employeeUserId
              },
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: WEB_ORGANISATION_SETTINGS_QUERY,
                variables: {
                  organisationId: organisationId
                }
              }, {
                query: USER_WORK_DAY_SETTINGS_QUERY,
                variables: {
                  organisationId: organisationId,
                  userId: employeeUserId,
                  timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
                }
              }]
            });
          case 3:
            response = _context5.sent;
            if ((response === null || response === void 0 ? void 0 : (_response$errors = response.errors) === null || _response$errors === void 0 ? void 0 : _response$errors.length) > 0) {
              toast.error("Failed to reset organisation settings. Try again.");
            } else if (response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.updateOrganisationSettingsForUser) {
              toast.success("Organisation settings reset successfully!");
              (_formikRef$current = formikRef.current) === null || _formikRef$current === void 0 ? void 0 : _formikRef$current.resetForm();
            } else {
              toast.error("Failed to reset organisation settings. Try again.");
            }
            _context5.next = 10;
            break;
          case 7:
            _context5.prev = 7;
            _context5.t0 = _context5["catch"](0);
            toast.error("Error occurred. Try again later.");
          case 10:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[0, 7]]);
    }));
    return function handleResetToOrganisationSettings() {
      return _ref12.apply(this, arguments);
    };
  }();
  var _useQuery6 = useQuery(USER_WORK_DAY_SETTINGS_QUERY, {
      variables: {
        organisationId: organisationId,
        userId: employeeUserId,
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
      },
      notifyOnNetworkStatusChange: true
    }),
    userWorkDayData = _useQuery6.data,
    userWorkDayError = _useQuery6.error,
    userWorkDayLoading = _useQuery6.loading,
    networkStatus = _useQuery6.networkStatus,
    refetch = _useQuery6.refetch;
  var isUserWorkDayLoading = userWorkDayLoading || networkStatus === NetworkStatus.refetch;
  React.useEffect(function () {
    if (employeeUserId != null) {
      refetch === null || refetch === void 0 ? void 0 : refetch();
    }
  }, [employeeUserId]);
  var workDaySettings = userWorkDayData === null || userWorkDayData === void 0 ? void 0 : (_userWorkDayData$user = userWorkDayData.userWorkDaySettings) === null || _userWorkDayData$user === void 0 ? void 0 : _userWorkDayData$user.userWorkSettings;
  var orgSettings = userWorkDayData === null || userWorkDayData === void 0 ? void 0 : (_userWorkDayData$user2 = userWorkDayData.userWorkDaySettings) === null || _userWorkDayData$user2 === void 0 ? void 0 : _userWorkDayData$user2.pageComponent;
  var UserDisplayName = userWorkDayData === null || userWorkDayData === void 0 ? void 0 : (_userWorkDayData$user3 = userWorkDayData.userWorkDaySettings) === null || _userWorkDayData$user3 === void 0 ? void 0 : (_userWorkDayData$user4 = _userWorkDayData$user3.user) === null || _userWorkDayData$user4 === void 0 ? void 0 : _userWorkDayData$user4.displayName;
  var showStealthMode = userWorkDayData === null || userWorkDayData === void 0 ? void 0 : (_userWorkDayData$user5 = userWorkDayData.userWorkDaySettings) === null || _userWorkDayData$user5 === void 0 ? void 0 : _userWorkDayData$user5.showStealthMode;
  var handleSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(values) {
      var variables, response;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            variables = {
              // workingDays: values.workingDays.join(),
              workingDays: null,
              screenCapture: (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.screenCapture) === values.screenCapture ? null : values.screenCapture.toString(),
              blurScreenCapture: (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.blurScreenCapture) === values.blurScreenCapture ? null : values.blurScreenCapture.toString(),
              screenCaptureInterval: (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.screenCaptureInterval) === values.screenCaptureInterval ? null : values.screenCaptureInterval,
              allowMemberToAccessScreenCapture: (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.allowMemberToAccessScreenCapture) === values.allowMemberToAccessScreenCapture ? null : values.allowMemberToAccessScreenCapture.toString(),
              allowMemberToDeleteScreenCapture: (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.allowMemberToDeleteScreenCapture) === values.allowMemberToDeleteScreenCapture ? null : values.allowMemberToDeleteScreenCapture.toString(),
              allowMemberToAccessTimesheet: (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.allowMemberToAccessTimesheet) === values.allowMemberToAccessTimesheet ? null : values.allowMemberToAccessTimesheet.toString(),
              allowMemberToAccessTimelapseVideo: (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.allowMemberToAccessTimelapseVideo) === values.allowMemberToAccessTimelapseVideo ? null : values.allowMemberToAccessTimelapseVideo.toString(),
              idleMinutesThreshold: (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.idleMinutesThreshold) === values.idleMinutesThreshold ? null : values.idleMinutesThreshold,
              stealthMode: (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.stealthMode) === values.stealthMode ? null : values.stealthMode.toString(),
              organisationId: organisationId,
              userId: employeeUserId,
              expectedClockInTime: (values === null || values === void 0 ? void 0 : values.expectedClockInTime) == null || (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.expectedClockInTime) === (values === null || values === void 0 ? void 0 : values.expectedClockInTime) ? null : moment(values === null || values === void 0 ? void 0 : values.expectedClockInTime).format("h:mm a"),
              timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
              trackAppsAndWebsites: (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.trackAppsAndWebsites) === values.trackAppsAndWebsites ? null : values.trackAppsAndWebsites.toString(),
              // organisationTimezone:
              //   workDaySettings?.organisationTimezone === values.organisationTimezone ? null : values.organisationTimezone,
              allowHeadToAccessTheirTeamMemberScreenCaptureAndTimelapseVideo: (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.allowHeadToAccessTheirTeamMemberScreenCaptureAndTimelapseVideo) === values.allowHeadToAccessTheirTeamMemberScreenCaptureAndTimelapseVideo ? null : values.allowHeadToAccessTheirTeamMemberScreenCaptureAndTimelapseVideo.toString(),
              autoClockIn: (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.autoClockIn) === values.autoClockIn ? null : values.autoClockIn.toString(),
              keyStrokeCounter: (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.keyStrokeCounter) === values.keyStrokeCounter ? null : values.keyStrokeCounter.toString(),
              mouseTracker: (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.mouseTracker) === values.mouseTracker ? null : values.mouseTracker.toString(),
              excludeUntrackedHours: (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.excludeUntrackedHours) === values.excludeUntrackedHours ? null : values.excludeUntrackedHours.toString(),
              expectedActiveTime: (workDaySettings === null || workDaySettings === void 0 ? void 0 : workDaySettings.expectedActiveTime) === values.expectedActiveTime ? null : values.expectedActiveTime
            };
            _context6.prev = 1;
            _context6.next = 4;
            return addUserWorkDaySettings({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: WEB_ORGANISATION_SETTINGS_QUERY,
                variables: {
                  organisationId: organisationId
                }
              }, {
                query: USER_WORK_DAY_SETTINGS_QUERY,
                variables: {
                  organisationId: organisationId,
                  userId: employeeUserId,
                  timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
                }
              }]
            });
          case 4:
            response = _context6.sent;
            if (!(!response || !response.data || response.data.addUserWorkDaySettings == null)) {
              _context6.next = 9;
              break;
            }
            throw new Error("error");
          case 9:
            toast.success("Setting updated successfully!");
          case 10:
            _context6.next = 15;
            break;
          case 12:
            _context6.prev = 12;
            _context6.t0 = _context6["catch"](1);
            console.log(_context6.t0);
          case 15:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[1, 12]]);
    }));
    return function (_x8) {
      return _ref13.apply(this, arguments);
    };
  }(), [addUserWorkDaySettings, addUserWorkDaySettingsLoading, workDaySettings]);

  // if (userWorkDayLoading) {
  //   return <div>Loading...</div>;
  // }

  // if (userWorkDayError) {
  //   return <div className="common-err-refresh-text">Something went wrong, please refresh the page.</div>;
  // }

  // if (!userWorkDayData) {
  //   return null;
  // }
  //console.log("userWorkDayData",userWorkDayData);

  var formats = "h:mm a";
  var expectedClockInOnChange = function expectedClockInOnChange(value, setFieldValue) {
    if (value !== null) {
      var data = value.format(formats);
      var arrData = data.split(" ");
      var finalTime = data;
      if (arrData[1] == "pm") {
        var hours = Number(data.match(/^(\d+)/)[1]);
        var minutes = Number(data.match(/:(\d+)/)[1]);
        var AMPM = data.match(/\s(.*)$/)[1];
        if (AMPM == "pm" && hours < 12) hours = hours + 12;
        var sHours = hours.toString();
        var sMinutes = minutes.toString();
        if (hours < 10) sHours = "0" + sHours;
        if (minutes < 10) sMinutes = "0" + sMinutes;
        finalTime = sHours + ":" + sMinutes;
      }
      setFieldValue("expectedClockInTime", value);
    } else {
      setFieldValue("expectedClockInTime", null);
    }
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleClose,
    centered: true,
    dialogClassName: "custom-dialog",
    contentClassName: isUserWorkDayLoading || userWorkDayError ? "new-employee-modal-setting-error" : "new-employee-modal-setting"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "manage-team-modal-title"
  }, "User Settings")), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("div", {
    className: "timesheet-settings-card-employee timesheet-setting-bottom"
  }, isUserWorkDayLoading ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Loader, null)) : userWorkDayError || !userWorkDayData ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : /*#__PURE__*/React.createElement(Formik, {
    innerRef: formikRef,
    enableReinitialize: true,
    initialValues: {
      // workingDays:
      //   workDaySettings.workingDays && workDaySettings.workingDays !== null
      //     ? workDaySettings.workingDays.split(",")
      //     : organisationSettings?.workingDays
      //     ? organisationSettings?.workingDays.split(",")
      //     : ["Monday"],
      screenCapture: (_workDaySettings$scre = workDaySettings.screenCapture) !== null && _workDaySettings$scre !== void 0 ? _workDaySettings$scre : false,
      blurScreenCapture: (_workDaySettings$blur = workDaySettings.blurScreenCapture) !== null && _workDaySettings$blur !== void 0 ? _workDaySettings$blur : false,
      screenCaptureInterval: (_workDaySettings$scre2 = workDaySettings.screenCaptureInterval) !== null && _workDaySettings$scre2 !== void 0 ? _workDaySettings$scre2 : "1",
      // generateTimelapseVideo: workDaySettings.generateTimelapseVideo ?? false,

      allowMemberToAccessScreenCapture: (_workDaySettings$allo = workDaySettings.allowMemberToAccessScreenCapture) !== null && _workDaySettings$allo !== void 0 ? _workDaySettings$allo : false,
      allowMemberToDeleteScreenCapture: (_workDaySettings$allo2 = workDaySettings.allowMemberToDeleteScreenCapture) !== null && _workDaySettings$allo2 !== void 0 ? _workDaySettings$allo2 : false,
      // allowHeadToDeleteTeamMemberScreenCapture:
      //   workDaySettings.allowHeadToDeleteTeamMemberScreenCapture ?? false,
      allowMemberToAccessTimesheet: (_workDaySettings$allo3 = workDaySettings.allowMemberToAccessTimesheet) !== null && _workDaySettings$allo3 !== void 0 ? _workDaySettings$allo3 : false,
      allowMemberToAccessTimelapseVideo: (_workDaySettings$allo4 = workDaySettings.allowMemberToAccessTimelapseVideo) !== null && _workDaySettings$allo4 !== void 0 ? _workDaySettings$allo4 : false,
      trackAppsAndWebsites: workDaySettings.trackAppsAndWebsites == null || workDaySettings.trackAppsAndWebsites == undefined ? true : workDaySettings.trackAppsAndWebsites,
      //idleMinutes: workDaySettings.idleMinutes ?? "",
      idleMinutesThreshold: (_workDaySettings$idle = workDaySettings.idleMinutesThreshold) !== null && _workDaySettings$idle !== void 0 ? _workDaySettings$idle : "1",
      //usbMonitoring: workDaySettings.usbMonitoring ?? false,
      stealthMode: (_workDaySettings$stea = workDaySettings.stealthMode) !== null && _workDaySettings$stea !== void 0 ? _workDaySettings$stea : false,
      expectedClockInTime: workDaySettings.expectedClockInTime ? moment(workDaySettings.expectedClockInTime) : organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.expectedClockInTime ? moment(organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.expectedClockInTime) : undefined,
      organisationTimezone: (_workDaySettings$orga = workDaySettings.organisationTimezone) !== null && _workDaySettings$orga !== void 0 ? _workDaySettings$orga : organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
      allowHeadToAccessTheirTeamMemberScreenCaptureAndTimelapseVideo: (_workDaySettings$allo5 = workDaySettings.allowHeadToAccessTheirTeamMemberScreenCaptureAndTimelapseVideo) !== null && _workDaySettings$allo5 !== void 0 ? _workDaySettings$allo5 : false,
      autoClockIn: (_workDaySettings$auto = workDaySettings.autoClockIn) !== null && _workDaySettings$auto !== void 0 ? _workDaySettings$auto : false,
      keyStrokeCounter: (_workDaySettings$keyS = workDaySettings.keyStrokeCounter) !== null && _workDaySettings$keyS !== void 0 ? _workDaySettings$keyS : false,
      mouseTracker: (_workDaySettings$mous = workDaySettings.mouseTracker) !== null && _workDaySettings$mous !== void 0 ? _workDaySettings$mous : false,
      excludeUntrackedHours: workDaySettings.excludeUntrackedHours == "true" ? "true" : "false",
      expectedActiveTime: (_workDaySettings$expe = workDaySettings.expectedActiveTime) !== null && _workDaySettings$expe !== void 0 ? _workDaySettings$expe : "420"
    }
    // validationSchema={MembersSchema}
    ,
    onSubmit: handleSubmit
  }, function (_ref14) {
    var isSubmitting = _ref14.isSubmitting,
      values = _ref14.values,
      setFieldValue = _ref14.setFieldValue;
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-employee "
    }, /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card-employee"
    }, /*#__PURE__*/React.createElement("h6", null, "Screenshot Settings"), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "screenCapture",
      checked: values.screenCapture,
      label: "Enable screen capture",
      id: "Enable-screen-capture",
      className: "manage-employee-edit-track-settings-checkbox"
      //isInvalid={emailError != null}
    })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "blurScreenCapture",
      disabled: values.screenCapture === true ? false : true,
      checked: values.blurScreenCapture,
      label: "Blur screen capture",
      id: "Blur-screen-capture"
      //isInvalid={emailError != null}
      ,
      className: "manage-employee-edit-track-settings-checkbox"
    })), /*#__PURE__*/React.createElement(Field, {
      name: "screenCaptureInterval"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        disabled: values.screenCapture === true ? false : true
      }, "Screen capture interval", " "), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(Form.Control, _extends({
        as: "select",
        disabled: values.screenCapture === true ? false : true,
        placeholder: "Select an interval"
      }, field), /*#__PURE__*/React.createElement("option", {
        value: "",
        disabled: true
      }, "Select an interval"), ScreenshotList.map(function (workingDays) {
        // if (
        //   Number(planConfig.screenshotMinimumTime) <= Number(workingDays.minsvalue) &&
        //   Number(planConfig.screenshotMaximumTime) <= Number(workingDays.minsvalue)
        // ) {
        return /*#__PURE__*/React.createElement("option", {
          key: workingDays.minsvalue,
          value: workingDays.minsvalue
        }, workingDays.mins);
        // }
      })));
    })), workDaySettings.stealthMode == true || organisationId == "d76fe280-390f-11ed-9b14-ebb2f09d4883" || organisationId == "efeee220-4107-11ed-a337-19c55260c92c" || organisationId == "cecea8b0-dfa6-11ef-bf0b-8fec61593eb4" ? /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card-employee"
    }, /*#__PURE__*/React.createElement("h6", null, "Stealth Mode (Beta Version)", " ", /*#__PURE__*/React.createElement(OverlayTrigger, {
      key: "currently-working",
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-top",
        className: "track-setting-tooltip-start"
      }, /*#__PURE__*/React.createElement("div", null, "If you enable the stealth mode, Tracking will be started automatically whenever your employee's system is ON."))
    }, /*#__PURE__*/React.createElement("span", {
      className: "track-setting-text-ques"
    }, " ", /*#__PURE__*/React.createElement(HiQuestionMarkCircle, null)))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "stealthMode",
      checked: values.stealthMode,
      label: "Enable stealth mode to ".concat(UserDisplayName.toLowerCase(), "'s system"),
      id: "stealth-mode",
      className: "manage-employee-edit-track-settings-checkbox"
    }))) : null, /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card-employee"
    }, /*#__PURE__*/React.createElement("h6", null, "Work Time Settings"), /*#__PURE__*/React.createElement(Field, {
      name: "expectedClockInTime"
    }, function (_ref15) {
      var field = _ref15.field,
        form = _ref15.form,
        meta = _ref15.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, "Expected Clock-in"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "Clock-in Time",
        value: values === null || values === void 0 ? void 0 : values.expectedClockInTime,
        className: meta.error && meta.touched ? "track-settings-formik-add-form-start-time-error" : "timesheet-settings-row-grid-employee-start-time",
        onChange: function onChange(e) {
          expectedClockInOnChange(e, setFieldValue);
        },
        placeholder: "Clock-in Time",
        format: formats,
        use12Hours: true,
        inputIcon: undefined
        // clearIcon={null}
        ,
        inputReadOnly: true
        // disabledHours={disabledStartTimeHours}
        // disabledMinutes={disabledStartTimeMinutes}
      })), values.expectedClockInTime === null && /*#__PURE__*/React.createElement("p", {
        className: "text-muted mt-1",
        style: {
          fontSize: "0.8rem"
        }
      }, "If you remove the employee-level expected clock-in time, the organization-level expected clock-in time will be applied automatically."));
    }), /*#__PURE__*/React.createElement(Field, {
      name: "expectedActiveTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, "Expected active time (Excluding idle time from total work time)"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(Form.Control, _extends({
        as: "select",
        placeholder: "Select an hour"
      }, field), expectedWorkingHourData.map(function (key, index) {
        return /*#__PURE__*/React.createElement("option", {
          key: key.mins,
          value: key.mins
        }, key.hours);
      })));
    })), /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card-employee"
    }, /*#__PURE__*/React.createElement("h6", null, "Tracking Settings"), /*#__PURE__*/React.createElement(Form.Group, {
      className: "timesheet-settings-row-grid-card-organisation-timezone"
    }, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "trackAppsAndWebsites",
      checked: values.trackAppsAndWebsites,
      label: "Track apps & websites",
      id: "Track-apps-websites"
      //isInvalid={emailError != null}
    }))), /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card"
    }, /*#__PURE__*/React.createElement("h6", null, "Untracked (Internet-Interrupted) Hours Settings "), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "timesheet-settings-row-grid-card-internet-interrupt-question"
    }, "Exclude hours with internet interruptions in total work hours?"), /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card-internet-interrupt-label"
    }, /*#__PURE__*/React.createElement(Form.Group, {
      className: "timesheet-settings-row-grid-card-internet-interrupt-label-include"
    }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(Field, {
      type: "radio",
      name: "excludeUntrackedHours",
      value: "true",
      checked: values.excludeUntrackedHours === "true" // Explicitly check the condition
      ,
      onClick: function onClick(e) {
        setFieldValue("excludeUntrackedHours", e.target.value);
      }
    }), /*#__PURE__*/React.createElement("span", null, "Yes - Exclude the untracked hours from total work time"))), /*#__PURE__*/React.createElement(Form.Group, {
      className: "timesheet-settings-row-grid-card-internet-interrupt-label-exclude"
    }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(Field, {
      type: "radio",
      name: "excludeUntrackedHours",
      value: "false",
      checked: values.excludeUntrackedHours === "false" // Explicitly check the condition
      ,
      onClick: function onClick(e) {
        setFieldValue("excludeUntrackedHours", e.target.value);
      }
    }), /*#__PURE__*/React.createElement("span", null, "No - Include the untracked hours to total work time")))))), /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card-employee"
    }, /*#__PURE__*/React.createElement("h6", null, "Permissions"), /*#__PURE__*/React.createElement(React.Fragment, null, employeeUserRole == "Head" ? /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "allowHeadToAccessTheirTeamMemberScreenCaptureAndTimelapseVideo",
      checked: values.allowHeadToAccessTheirTeamMemberScreenCaptureAndTimelapseVideo,
      disabled: values.screenCapture === true ? false : true,
      label: "Allow ".concat(UserDisplayName.toLowerCase(), " to see team member's screenshots and timelapse video"),
      id: "Allow-the-employee-to-see-their-team-member-screen-capture-and-timelapse-video",
      className: "manage-employee-edit-track-settings-checkbox"
      //isInvalid={emailError != null}
    })) : null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "allowMemberToAccessScreenCapture",
      checked: values.allowMemberToAccessScreenCapture,
      disabled: values.screenCapture === true ? false : true,
      label: "Allow ".concat(UserDisplayName.toLowerCase(), " to see their screen capture"),
      id: "Allow-the-employee-to-see-their-screen-capture",
      className: "manage-employee-edit-track-settings-checkbox"
      //isInvalid={emailError != null}
    })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "allowMemberToDeleteScreenCapture",
      checked: values.allowMemberToDeleteScreenCapture,
      disabled: values.screenCapture === true && values.allowMemberToAccessScreenCapture === true ? false : true,
      label: "Allow ".concat(UserDisplayName.toLowerCase(), " to delete their screen capture"),
      id: "Allow-employee-to-delete-their-screen-capture",
      className: "manage-employee-edit-track-settings-checkbox"
      //isInvalid={emailError != null}
    }))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "allowMemberToAccessTimesheet",
      checked: values.allowMemberToAccessTimesheet,
      label: "Allow ".concat(UserDisplayName.toLowerCase(), " to see their timesheet"),
      id: "Allow-the-employee-to-see-their-timesheet",
      className: "manage-employee-edit-track-settings-checkbox"
      //isInvalid={emailError != null}
    })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "allowMemberToAccessTimelapseVideo",
      checked: values.allowMemberToAccessTimelapseVideo,
      disabled: values.screenCapture === true && values.allowMemberToAccessScreenCapture === true ? false : true,
      label: "Allow ".concat(UserDisplayName.toLowerCase(), " to see their time-lapse video"),
      id: "Allow-the-employee-to-see-their-time-lapse-video*",
      className: "manage-employee-edit-track-settings-checkbox"
      //isInvalid={emailError != null}
    }))), (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == "83844da8-71e8-4e94-b6ac-aaff5d8a858c" || organisationId == "f2c9e240-4e71-11eb-9784-794f853f90e2" || organisationId == "22cb3fb0-a27a-11ef-992a-a3d490cf2e0d" || organisationId == "5da90b00-1205-11ee-99eb-6f59a4034ddc" || organisationId == "35fcc020-e2ec-11ee-9c92-a7c3dd681c18" || organisationId == "0b05daf0-1a59-11f0-ab0d-8dc7aeb69888" || organisationId == "3c1ddfd0-21b6-11ef-8be8-25513e762037" || organisationId == "b8a0b6a0-389b-11ed-9b14-ebb2f09d4883" || organisationId == "37b19790-9206-11f0-acfe-091be3718816" ? /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card-employee"
    }, /*#__PURE__*/React.createElement("h6", null, "Keyboard & Mouse Activity Tracking", /*#__PURE__*/React.createElement("sup", {
      "class": "page-content-wrapper-header-name-sup-project-track-settings"
    }, "Premium"), " ", /*#__PURE__*/React.createElement("span", {
      className: "timesheet-settings-row-grid-card-manual-time-card-header-span-mouse"
    }, /*#__PURE__*/React.createElement("a", {
      href: "https://workfolio.tawk.help/article/keyboard-mouse-activity-tracking",
      target: "_blank"
    }, "(Learn more)"))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "keyStrokeCounter",
      checked: values.keyStrokeCounter,
      label: "Enable Track Keypress Count on Windows",
      id: "enable-keypress-tracking"
      //isInvalid={emailError != null}
      ,
      className: "track-settingts-checkbox"
    }), /*#__PURE__*/React.createElement("p", {
      className: "timesheet-settings-row-grid-card-mouse-p"
    }, "Tracks how many keys a user presses during work hours.")), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "mouseTracker",
      checked: values.mouseTracker,
      label: "Enable Mouse Activity Tracking on Windows",
      id: "enable-mouse-activity-tracking"
      //isInvalid={emailError != null}
      ,
      className: "track-settingts-checkbox"
    }), /*#__PURE__*/React.createElement("p", {
      className: "timesheet-settings-row-grid-card-mouse-p"
    }, "Tracks mouse clicks, scrolls, and movement to measure interaction."))) : /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card"
    }, /*#__PURE__*/React.createElement("h6", null, "Keyboard & Mouse Activity Tracking", /*#__PURE__*/React.createElement("sup", {
      "class": "page-content-wrapper-header-name-sup-project-track-settings"
    }, "Premium"), " ", /*#__PURE__*/React.createElement("span", {
      className: "timesheet-settings-row-grid-card-manual-time-card-header-span"
    }, /*#__PURE__*/React.createElement("a", {
      href: "https://workfolio.tawk.help/article/keyboard-mouse-activity-tracking",
      target: "_blank"
    }, "(Learn more)"))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "keyStrokeCounter",
      disabled: true,
      label: "Enable Track Keypress Count on Windows",
      id: "enable-keypress-tracking",
      className: "track-settingts-checkbox"
    }), /*#__PURE__*/React.createElement("p", {
      className: "timesheet-settings-row-grid-card-mouse-p"
    }, "Tracks how many keys a user presses during work hours.")), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "mouseTracker",
      disabled: true,
      label: "Enable Mouse Activity Tracking on Windows",
      id: "enable-mouse-activity-tracking"
      //isInvalid={emailError != null}
      ,
      className: "track-settingts-checkbox"
    }), /*#__PURE__*/React.createElement("p", {
      className: "timesheet-settings-row-grid-card-mouse-p"
    }, "Tracks mouse clicks, scrolls, and movement to measure interaction."))), /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card-employee"
    }, /*#__PURE__*/React.createElement("h6", null, "Idle Time Settings"), /*#__PURE__*/React.createElement(Field, {
      name: "idleMinutesThreshold"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, "Start to consider as idle if ", UserDisplayName.toLowerCase(), " is inactive for", /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Form.Control, _extends({
        as: "select",
        className: "user-employee-idel-threshold-dropdown"
        //disabled={values.screenCapture === true ? false : true}
        ,
        placeholder: "Select a minutes"
      }, field), /*#__PURE__*/React.createElement("option", {
        value: "",
        disabled: workDaySettings.idleMinutesThreshold
      }, "Select a minutes"), IdelTimeThresholdList.map(function (workingDays) {
        return /*#__PURE__*/React.createElement("option", {
          key: workingDays.minsvalue,
          value: workingDays.minsvalue
        }, workingDays.mins);
      })))), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, meta.error) : null);
    })), organisationId == "629823d0-ea16-11eb-8ecf-fd402ded7fa3" ? /*#__PURE__*/React.createElement("div", {
      className: "timesheet-settings-row-grid-card-employee"
    }, /*#__PURE__*/React.createElement("h6", null, "Organisation timezone"), /*#__PURE__*/React.createElement(Field, {
      name: "organisationTimezone"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(Form.Control, _extends({
        as: "select",
        placeholder: "Select an timezone",
        className: "timesheet-settings-row-grid-card-employee-timezone-select"
      }, field), timezoneList.map(function (timezone) {
        return /*#__PURE__*/React.createElement("option", {
          key: timezone.value,
          value: timezone.value
        }, timezone.label);
        // }
      })));
    })) : null), /*#__PURE__*/React.createElement("div", {
      className: "d-flex timesheet-setting-buttons-row"
    }, /*#__PURE__*/React.createElement(Button, {
      className: "timesheet-setting-sub-button",
      type: "submit",
      disabled: addUserWorkDaySettingsLoading || isSubmitting
    }, addUserWorkDaySettingsLoading || isSubmitting ? "Loading..." : "Save User Track Settings"), /*#__PURE__*/React.createElement(Button, {
      className: "timesheet-setting-sub-button",
      variant: "outline-secondary",
      type: "button",
      disabled: updateOrgSettingsLoading,
      onClick: handleResetToOrganisationSettings
    }, updateOrgSettingsLoading ? "Loading..." : "Reset to Organisation Settings"))));
  }))));
};
var EmployeeBillable = function EmployeeBillable(props) {
  var employeeBillableModal = props.employeeBillableModal,
    handleClose = props.handleClose,
    organisationId = props.organisationId,
    teamId = props.teamId,
    role = props.role,
    organisationBilling = props.organisationBilling,
    organisationSettings = props.organisationSettings,
    editUserData = props.editUserData,
    setEditUserData = props.setEditUserData,
    currenciesData = props.currenciesData;
  if (employeeBillableModal == null) {
    return null;
  }
  var _React$useState35 = React.useState(new Date()),
    _React$useState36 = _slicedToArray(_React$useState35, 2),
    startDate = _React$useState36[0],
    setStartDate = _React$useState36[1];
  var _React$useState37 = React.useState(new Date()),
    _React$useState38 = _slicedToArray(_React$useState37, 2),
    endDate = _React$useState38[0],
    setEndDate = _React$useState38[1];
  var _React$useState39 = React.useState(false),
    _React$useState40 = _slicedToArray(_React$useState39, 2),
    isNavClick = _React$useState40[0],
    setNavClick = _React$useState40[1];
  var _React$useContext6 = React.useContext(SearchContext),
    search = _React$useContext6.search;
  var _useMutation13 = useMutation(ADD_BILLABLE_RATE_MUTATION),
    _useMutation14 = _slicedToArray(_useMutation13, 2),
    addBillableRateForUsers = _useMutation14[0],
    billableRateLoading = _useMutation14[1].loading;
  var handleSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(values, actions) {
      var amount, billableTime, variables, response, editUser, findEditUserId;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            amount = values.amount, billableTime = values.billableTime;
            variables = {
              amount: amount,
              userId: employeeBillableModal.userId,
              billableTime: billableTime == "now" ? moment(startDate).isSame(moment(), "day") ? "now" : "someDate" : billableTime,
              startDate: Number(moment(startDate).startOf("day").format("x")),
              endDate: Number(moment(endDate).endOf("day").format("x")),
              timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
              organisationId: organisationId
            };
            _context7.prev = 2;
            _context7.next = 5;
            return addBillableRateForUsers({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: ORGANISATION_USERS_COUNT_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userRole: role
                }
              }, {
                query: ORGANISATION_USERS_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userRole: role,
                  limit: LIMIT,
                  offset: 0,
                  searchText: search
                }
              }]
            });
          case 5:
            response = _context7.sent;
            if (response || response.data || response.data.addBillableRateForUsers) {
              editUser = editUserData;
              findEditUserId = editUser.find(function (user) {
                return user.userId === response.data.addBillableRateForUsers.userId;
              }) || {};
              if (Object.keys(findEditUserId).length > 0) {
                editUser = editUser.filter(function (val) {
                  if (val.userId !== response.data.addBillableRateForUsers.userId) {
                    return val;
                  }
                });
              }
              editUser.push(response.data.addBillableRateForUsers);
              setEditUserData(editUser);
            }
            if (!(!response || !response.data || !response.data.addBillableRateForUsers)) {
              _context7.next = 11;
              break;
            }
            throw new Error("error");
          case 11:
            handleClose();
            toast.success("Billable rate added successfully!");
          case 13:
            _context7.next = 19;
            break;
          case 15:
            _context7.prev = 15;
            _context7.t0 = _context7["catch"](2);
            console.log("error", _context7.t0);
            toast.success("Error Occured, Try again later!");
          case 19:
          case "end":
            return _context7.stop();
        }
      }, _callee7, null, [[2, 15]]);
    }));
    return function (_x9, _x10) {
      return _ref16.apply(this, arguments);
    };
  }(), [addBillableRateForUsers, billableRateLoading, startDate, endDate]);
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleClose,
    centered: true
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "manage-team-modal-title"
  }, "Set Billable Rate to", " ", /*#__PURE__*/React.createElement("span", {
    className: "billable-rate-modal-heading-span"
  }, employeeBillableModal.displayName))), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      amount: employeeBillableModal.billableRate == 0 || employeeBillableModal.billableRate == null ? "" : employeeBillableModal.billableRate,
      billableTime: (employeeBillableModal === null || employeeBillableModal === void 0 ? void 0 : employeeBillableModal.billableRateType) == null || (employeeBillableModal === null || employeeBillableModal === void 0 ? void 0 : employeeBillableModal.billableRateType) == "now" ? "now" : (employeeBillableModal === null || employeeBillableModal === void 0 ? void 0 : employeeBillableModal.billableRateType) == "past" ? "past" : null
    },
    validationSchema: BillableSchema,
    onSubmit: handleSubmit
  }, function (_ref17) {
    var setFieldValue = _ref17.setFieldValue,
      errors = _ref17.errors,
      touched = _ref17.touched;
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Form.Group, {
      className: "employee-billable-form"
    }, /*#__PURE__*/React.createElement(Alert, {
      key: "billable-note-primary",
      variant: "primary",
      className: "employee-billable-form-whole-div"
    }, "We'll apply this rate to all entries made by ", employeeBillableModal.displayName, "."), /*#__PURE__*/React.createElement(Form.Label, {
      className: "billable-rate-label-div"
    }, "Billable rate (in ", currenciesData, ")"), /*#__PURE__*/React.createElement("div", {
      className: "manage-employee-dollar-text-div"
    }, /*#__PURE__*/React.createElement(Field, {
      className: "manage-billable-form-bill",
      as: Form.Control,
      name: "amount",
      type: "number",
      placeholder: "Bill rate",
      required: true,
      isInvalid: touched.amount && errors.amount,
      min: "0"
    }), /*#__PURE__*/React.createElement("span", {
      className: "manage-employee-dollar-text"
    }, currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R" : currenciesData == "SEK" ? "kr" : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM" : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs" : "$"))), /*#__PURE__*/React.createElement(Form.Group, {
      className: "employee-billable-form"
    }, /*#__PURE__*/React.createElement(Form.Label, {
      className: "billable-rate-label-div"
    }, "Apply this billable rate to "), /*#__PURE__*/React.createElement("div", {
      className: ""
    }, /*#__PURE__*/React.createElement("div", {
      className: "bilable-rate-time-whole-div"
    }, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      value: "now",
      name: "billableTime",
      id: "billable-time-now",
      className: "scheduled-reports-new-report-modal-radion-button"
    }), /*#__PURE__*/React.createElement("div", {
      className: "bilable-rate-time-div-datepicker-text"
    }, "Time entries from", " ", /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Dropdown, {
      open: isNavClick,
      className: classNames("bilable-rate-time-div-datepicker .btn-primary")
    }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
      id: "dropdown-basics"
    }, moment(startDate).isSame(moment(), "day") ? "now" : moment(startDate).format("DD MMM, YYYY")), /*#__PURE__*/React.createElement(Dropdown.Menu, {
      className: "page-content-wrapper-menu-filter-overlay-trigger bilable-rate-time-div-datepicker-inside"
    }, /*#__PURE__*/React.createElement(DatePicker, {
      selected: startDate,
      inline: true,
      onChange: function onChange(date) {
        return setStartDate(date);
      },
      minDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" ? subDays(new Date(), 13) : null,
      maxDate: new Date()
      //className="bilable-rate-time-div-datepicker-inside"
    })))), " ", /*#__PURE__*/React.createElement("span", null, "onwards "))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "All past and future time entries",
      value: "past",
      name: "billableTime",
      id: "billable-time-past",
      className: "scheduled-reports-new-report-modal-radion-button"
    })))))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: "manage-billable-team-modal-button "
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      className: "manage-team-modal-save-button",
      type: "submit"
    }, billableRateLoading ? "Loading..." : "Save")))))));
  })));
};
var EmployeeLabourCost = function EmployeeLabourCost(props) {
  var employeeLabourCostModal = props.employeeLabourCostModal,
    handleClose = props.handleClose,
    organisationId = props.organisationId,
    teamId = props.teamId,
    role = props.role,
    organisationBilling = props.organisationBilling,
    organisationSettings = props.organisationSettings,
    editUserData = props.editUserData,
    setEditUserData = props.setEditUserData,
    currenciesData = props.currenciesData;
  if (employeeLabourCostModal == null) {
    return null;
  }
  var _React$useState41 = React.useState(new Date()),
    _React$useState42 = _slicedToArray(_React$useState41, 2),
    startDate = _React$useState42[0],
    setStartDate = _React$useState42[1];
  var _React$useState43 = React.useState(new Date()),
    _React$useState44 = _slicedToArray(_React$useState43, 2),
    endDate = _React$useState44[0],
    setEndDate = _React$useState44[1];
  var _React$useState45 = React.useState(false),
    _React$useState46 = _slicedToArray(_React$useState45, 2),
    isNavClick = _React$useState46[0],
    setNavClick = _React$useState46[1];
  var _React$useContext7 = React.useContext(SearchContext),
    search = _React$useContext7.search;
  var _useMutation15 = useMutation(ADD_LABOUR_COST_MUTATION),
    _useMutation16 = _slicedToArray(_useMutation15, 2),
    addLabourCostForUsers = _useMutation16[0],
    labourCostLoading = _useMutation16[1].loading;
  var handleSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(values, actions) {
      var amount, labourTime, variables, response, editUser, findEditUserId;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            amount = values.amount, labourTime = values.labourTime;
            variables = {
              amount: amount,
              userId: employeeLabourCostModal.userId,
              labourTime: labourTime == "now" ? moment(startDate).isSame(moment(), "day") ? "now" : "someDate" : labourTime,
              startDate: Number(moment(startDate).startOf("day").format("x")),
              endDate: Number(moment(endDate).endOf("day").format("x")),
              timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
              organisationId: organisationId
            };
            _context8.prev = 2;
            _context8.next = 5;
            return addLabourCostForUsers({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: ORGANISATION_USERS_COUNT_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userRole: role
                }
              }, {
                query: ORGANISATION_USERS_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userRole: role,
                  limit: LIMIT,
                  offset: 0,
                  searchText: search
                }
              }]
            });
          case 5:
            response = _context8.sent;
            if (response || response.data || response.data.addLabourCostForUsers) {
              editUser = editUserData;
              findEditUserId = editUser.find(function (user) {
                return user.userId === response.data.addLabourCostForUsers.userId;
              }) || {};
              if (Object.keys(findEditUserId).length > 0) {
                editUser = editUser.filter(function (val) {
                  if (val.userId !== response.data.addLabourCostForUsers.userId) {
                    return val;
                  }
                });
              }
              editUser.push(response.data.addLabourCostForUsers);
              setEditUserData(editUser);
            }
            if (!(!response || !response.data || !response.data.addLabourCostForUsers)) {
              _context8.next = 11;
              break;
            }
            throw new Error("error");
          case 11:
            handleClose();
            toast.success("Labour cost added successfully!");
          case 13:
            _context8.next = 19;
            break;
          case 15:
            _context8.prev = 15;
            _context8.t0 = _context8["catch"](2);
            console.log("error", _context8.t0);
            toast.success("Error Occured, Try again later!");
          case 19:
          case "end":
            return _context8.stop();
        }
      }, _callee8, null, [[2, 15]]);
    }));
    return function (_x11, _x12) {
      return _ref18.apply(this, arguments);
    };
  }(), [addLabourCostForUsers, labourCostLoading, startDate, endDate]);
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleClose,
    centered: true
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "manage-team-modal-title"
  }, "Set Labour Cost to", " ", /*#__PURE__*/React.createElement("span", {
    className: "billable-rate-modal-heading-span"
  }, employeeLabourCostModal.displayName))), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      amount: employeeLabourCostModal.labourCost == 0 || employeeLabourCostModal.labourCost == null ? "" : employeeLabourCostModal.labourCost,
      labourTime: (employeeLabourCostModal === null || employeeLabourCostModal === void 0 ? void 0 : employeeLabourCostModal.labourCostType) == null || (employeeLabourCostModal === null || employeeLabourCostModal === void 0 ? void 0 : employeeLabourCostModal.labourCostType) == "now" ? "now" : (employeeLabourCostModal === null || employeeLabourCostModal === void 0 ? void 0 : employeeLabourCostModal.labourCostType) == "past" ? "past" : null
    },
    validationSchema: LabourSchema,
    onSubmit: handleSubmit
  }, function (_ref19) {
    var setFieldValue = _ref19.setFieldValue,
      errors = _ref19.errors,
      touched = _ref19.touched;
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Form.Group, {
      className: "employee-billable-form"
    }, /*#__PURE__*/React.createElement(Alert, {
      key: "billable-note-primary",
      variant: "primary",
      className: "employee-billable-form-whole-div"
    }, "We'll apply this rate to all entries made by ", employeeLabourCostModal.displayName, "."), /*#__PURE__*/React.createElement(Form.Label, {
      className: "billable-rate-label-div"
    }, "Labour cost (in ", currenciesData, ")"), /*#__PURE__*/React.createElement("div", {
      className: "manage-employee-dollar-text-div"
    }, /*#__PURE__*/React.createElement(Field, {
      className: "manage-billable-form",
      as: Form.Control,
      name: "amount",
      type: "number",
      placeholder: "Labour cost",
      required: true,
      isInvalid: touched.amount && errors.amount,
      min: "0"
    }), /*#__PURE__*/React.createElement("span", {
      className: "manage-employee-dollar-text"
    }, currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R" : currenciesData == "SEK" ? "kr" : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM" : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs" : "$"))), /*#__PURE__*/React.createElement(Form.Group, {
      className: "employee-billable-form"
    }, /*#__PURE__*/React.createElement(Form.Label, {
      className: "billable-rate-label-div"
    }, "Apply this labour cost to "), /*#__PURE__*/React.createElement("div", {
      className: ""
    }, /*#__PURE__*/React.createElement("div", {
      className: "bilable-rate-time-whole-div"
    }, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      value: "now",
      name: "labourTime",
      id: "billable-time-now",
      className: "scheduled-reports-new-report-modal-radion-button"
    }), /*#__PURE__*/React.createElement("div", {
      className: "bilable-rate-time-div-datepicker-text"
    }, "Time entries from", " ", /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Dropdown, {
      open: isNavClick,
      className: classNames("bilable-rate-time-div-datepicker .btn-primary")
    }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
      id: "dropdown-basics"
    }, moment(startDate).isSame(moment(), "day") ? "now" : moment(startDate).format("DD MMM, YYYY")), /*#__PURE__*/React.createElement(Dropdown.Menu, {
      className: "page-content-wrapper-menu-filter-overlay-trigger bilable-rate-time-div-datepicker-inside"
    }, /*#__PURE__*/React.createElement(DatePicker, {
      selected: startDate,
      inline: true,
      onChange: function onChange(date) {
        return setStartDate(date);
      },
      minDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" ? subDays(new Date(), 13) : null,
      maxDate: new Date()
    })))), " ", /*#__PURE__*/React.createElement("span", null, "onwards "))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "All past and future time entries",
      value: "past",
      name: "labourTime",
      id: "billable-time-past",
      className: "scheduled-reports-new-report-modal-radion-button"
    })))))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: "manage-billable-team-modal-button "
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      className: "manage-team-modal-save-button",
      type: "submit"
    }, labourCostLoading ? "Loading..." : "Save")))))));
  })));
};
export default Employees;